window.object_name = 'fleshlight';

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 */

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend(jQuery.easing, {
  def: 'easeOutQuad',
  swing: function(x, t, b, c, d) {
    //alert(jQuery.easing.default);
    return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
  },
  easeInQuad: function(x, t, b, c, d) {
    return c * (t /= d) * t + b;
  },
  easeOutQuad: function(x, t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
  },
  easeInOutQuad: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
    return -c / 2 * ((--t) * (t - 2) - 1) + b;
  },
  easeInCubic: function(x, t, b, c, d) {
    return c * (t /= d) * t * t + b;
  },
  easeOutCubic: function(x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  },
  easeInOutCubic: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
    return c / 2 * ((t -= 2) * t * t + 2) + b;
  },
  easeInQuart: function(x, t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
  },
  easeOutQuart: function(x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  },
  easeInOutQuart: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
  },
  easeInQuint: function(x, t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  },
  easeOutQuint: function(x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  },
  easeInOutQuint: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
  },
  easeInSine: function(x, t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  },
  easeOutSine: function(x, t, b, c, d) {
    return c * Math.sin(t / d * (Math.PI / 2)) + b;
  },
  easeInOutSine: function(x, t, b, c, d) {
    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
  },
  easeInExpo: function(x, t, b, c, d) {
    return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
  },
  easeOutExpo: function(x, t, b, c, d) {
    return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
  },
  easeInOutExpo: function(x, t, b, c, d) {
    if (t == 0) return b;
    if (t == d) return b + c;
    if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
  },
  easeInCirc: function(x, t, b, c, d) {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  },
  easeOutCirc: function(x, t, b, c, d) {
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  },
  easeInOutCirc: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  },
  easeInElastic: function(x, t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * .3;
    if (a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(c / a);
    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
  },
  easeOutElastic: function(x, t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * .3;
    if (a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(c / a);
    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
  },
  easeInOutElastic: function(x, t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d / 2) == 2) return b + c;
    if (!p) p = d * (.3 * 1.5);
    if (a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(c / a);
    if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
  },
  easeInBack: function(x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  },
  easeOutBack: function(x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  },
  easeInOutBack: function(x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
    return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
  },
  easeInBounce: function(x, t, b, c, d) {
    return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
  },
  easeOutBounce: function(x, t, b, c, d) {
    if ((t /= d) < (1 / 2.75)) {
      return c * (7.5625 * t * t) + b;
    } else if (t < (2 / 2.75)) {
      return c * (7.5625 * (t -= (1.5 / 2.75)) * t + .75) + b;
    } else if (t < (2.5 / 2.75)) {
      return c * (7.5625 * (t -= (2.25 / 2.75)) * t + .9375) + b;
    } else {
      return c * (7.5625 * (t -= (2.625 / 2.75)) * t + .984375) + b;
    }
  },
  easeInOutBounce: function(x, t, b, c, d) {
    if (t < d / 2) return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
    return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
  }
});

/**
 * Owl carousel
 * @version 2.0.0
 */
;
(function($, window, document, undefined) {

  var drag, state, e;

  /**
   * Template for status information about drag and touch events.
   * @private
   */
  drag = {
    start: 0,
    startX: 0,
    startY: 0,
    current: 0,
    currentX: 0,
    currentY: 0,
    offsetX: 0,
    offsetY: 0,
    distance: null,
    startTime: 0,
    endTime: 0,
    updatedX: 0,
    targetEl: null
  };

  /**
   * Template for some status informations.
   * @private
   */
  state = {
    isTouch: false,
    isScrolling: false,
    isSwiping: false,
    direction: false,
    inMotion: false
  };

  /**
   * Event functions references.
   * @private
   */
  e = {
    _onDragStart: null,
    _onDragMove: null,
    _onDragEnd: null,
    _transitionEnd: null,
    _resizer: null,
    _responsiveCall: null,
    _goToLoop: null,
    _checkVisibile: null
  };

  /**
   * Creates a carousel.
   * @class The Owl Carousel.
   * @public
   * @param {HTMLElement|jQuery} element - The element to create the carousel for.
   * @param {Object} [options] - The options
   */
  function Owl(element, options) {

    /**
     * Current settings for the carousel.
     * @public
     */
    this.settings = null;

    /**
     * Current options set by the caller including defaults.
     * @public
     */
    this.options = $.extend({}, Owl.Defaults, options);

    /**
     * Plugin element.
     * @public
     */
    this.$element = $(element);

    /**
     * Caches informations about drag and touch events.
     */
    this.drag = $.extend({}, drag);

    /**
     * Caches some status informations.
     * @protected
     */
    this.state = $.extend({}, state);

    /**
     * @protected
     * @todo Must be documented
     */
    this.e = $.extend({}, e);

    /**
     * References to the running plugins of this carousel.
     * @protected
     */
    this._plugins = {};

    /**
     * Currently suppressed events to prevent them from beeing retriggered.
     * @protected
     */
    this._supress = {};

    /**
     * Absolute current position.
     * @protected
     */
    this._current = null;

    /**
     * Animation speed in milliseconds.
     * @protected
     */
    this._speed = null;

    /**
     * Coordinates of all items in pixel.
     * @todo The name of this member is missleading.
     * @protected
     */
    this._coordinates = [];

    /**
     * Current breakpoint.
     * @todo Real media queries would be nice.
     * @protected
     */
    this._breakpoint = null;

    /**
     * Current width of the plugin element.
     */
    this._width = null;

    /**
     * All real items.
     * @protected
     */
    this._items = [];

    /**
     * All cloned items.
     * @protected
     */
    this._clones = [];

    /**
     * Merge values of all items.
     * @todo Maybe this could be part of a plugin.
     * @protected
     */
    this._mergers = [];

    /**
     * Invalidated parts within the update process.
     * @protected
     */
    this._invalidated = {};

    /**
     * Ordered list of workers for the update process.
     * @protected
     */
    this._pipe = [];

    $.each(Owl.Plugins, $.proxy(function(key, plugin) {
      this._plugins[key[0].toLowerCase() + key.slice(1)] = new plugin(this);
    }, this));

    $.each(Owl.Pipe, $.proxy(function(priority, worker) {
      this._pipe.push({
        'filter': worker.filter,
        'run': $.proxy(worker.run, this)
      });
    }, this));

    this.setup();
    this.initialize();
  }

  /**
   * Default options for the carousel.
   * @public
   */
  Owl.Defaults = {
    items: 3,
    loop: false,
    center: false,

    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    freeDrag: false,

    margin: 0,
    stagePadding: 0,

    merge: false,
    mergeFit: true,
    autoWidth: false,

    startPosition: 0,
    rtl: false,

    smartSpeed: 250,
    fluidSpeed: false,
    dragEndSpeed: false,

    responsive: {},
    responsiveRefreshRate: 200,
    responsiveBaseElement: window,
    responsiveClass: false,

    fallbackEasing: 'swing',

    info: false,

    nestedItemSelector: false,
    itemElement: 'div',
    stageElement: 'div',

    // Classes and Names
    themeClass: 'owl-theme',
    baseClass: 'owl-carousel',
    itemClass: 'owl-item',
    centerClass: 'center',
    activeClass: 'active'
  };

  /**
   * Enumeration for width.
   * @public
   * @readonly
   * @enum {String}
   */
  Owl.Width = {
    Default: 'default',
    Inner: 'inner',
    Outer: 'outer'
  };

  /**
   * Contains all registered plugins.
   * @public
   */
  Owl.Plugins = {};

  /**
   * Update pipe.
   */
  Owl.Pipe = [{
    filter: ['width', 'items', 'settings'],
    run: function(cache) {
      cache.current = this._items && this._items[this.relative(this._current)];
    }
  }, {
    filter: ['items', 'settings'],
    run: function() {
      var cached = this._clones,
        clones = this.$stage.children('.cloned');

      if (clones.length !== cached.length || (!this.settings.loop && cached.length > 0)) {
        this.$stage.children('.cloned').remove();
        this._clones = [];
      }
    }
  }, {
    filter: ['items', 'settings'],
    run: function() {
      var i, n,
        clones = this._clones,
        items = this._items,
        delta = this.settings.loop ? clones.length - Math.max(this.settings.items * 2, 4) : 0;

      for (i = 0, n = Math.abs(delta / 2); i < n; i++) {
        if (delta > 0) {
          this.$stage.children().eq(items.length + clones.length - 1).remove();
          clones.pop();
          this.$stage.children().eq(0).remove();
          clones.pop();
        } else {
          clones.push(clones.length / 2);
          this.$stage.append(items[clones[clones.length - 1]].clone().addClass('cloned'));
          clones.push(items.length - 1 - (clones.length - 1) / 2);
          this.$stage.prepend(items[clones[clones.length - 1]].clone().addClass('cloned'));
        }
      }
    }
  }, {
    filter: ['width', 'items', 'settings'],
    run: function() {
      var rtl = (this.settings.rtl ? 1 : -1),
        width = (this.width() / this.settings.items).toFixed(3),
        coordinate = 0,
        merge, i, n;

      this._coordinates = [];
      for (i = 0, n = this._clones.length + this._items.length; i < n; i++) {
        merge = this._mergers[this.relative(i)];
        merge = (this.settings.mergeFit && Math.min(merge, this.settings.items)) || merge;
        coordinate += (this.settings.autoWidth ? this._items[this.relative(i)].width() + this.settings.margin : width * merge) * rtl;

        this._coordinates.push(coordinate);
      }
    }
  }, {
    filter: ['width', 'items', 'settings'],
    run: function() {
      var i, n, width = (this.width() / this.settings.items).toFixed(3),
        css = {
          'width': Math.abs(this._coordinates[this._coordinates.length - 1]) + this.settings.stagePadding * 2,
          'padding-left': this.settings.stagePadding || '',
          'padding-right': this.settings.stagePadding || ''
        };

      this.$stage.css(css);

      css = {
        'width': this.settings.autoWidth ? 'auto' : width - this.settings.margin
      };
      css[this.settings.rtl ? 'margin-left' : 'margin-right'] = this.settings.margin;

      if (!this.settings.autoWidth && $.grep(this._mergers, function(v) {
          return v > 1
        }).length > 0) {
        for (i = 0, n = this._coordinates.length; i < n; i++) {
          css.width = Math.abs(this._coordinates[i]) - Math.abs(this._coordinates[i - 1] || 0) - this.settings.margin;
          this.$stage.children().eq(i).css(css);
        }
      } else {
        this.$stage.children().css(css);
      }
    }
  }, {
    filter: ['width', 'items', 'settings'],
    run: function(cache) {
      cache.current && this.reset(this.$stage.children().index(cache.current));
    }
  }, {
    filter: ['position'],
    run: function() {
      this.animate(this.coordinates(this._current));
    }
  }, {
    filter: ['width', 'position', 'items', 'settings'],
    run: function() {
      var rtl = this.settings.rtl ? 1 : -1,
        padding = this.settings.stagePadding * 2,
        begin = this.coordinates(this.current()) + padding,
        end = begin + this.width() * rtl,
        inner, outer, matches = [],
        i, n;

      for (i = 0, n = this._coordinates.length; i < n; i++) {
        inner = this._coordinates[i - 1] || 0;
        outer = Math.abs(this._coordinates[i]) + padding * rtl;

        if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end))) ||
          (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
          matches.push(i);
        }
      }

      this.$stage.children('.' + this.settings.activeClass).removeClass(this.settings.activeClass);
      this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass(this.settings.activeClass);

      if (this.settings.center) {
        this.$stage.children('.' + this.settings.centerClass).removeClass(this.settings.centerClass);
        this.$stage.children().eq(this.current()).addClass(this.settings.centerClass);
      }
    }
  }];

  /**
   * Initializes the carousel.
   * @protected
   */
  Owl.prototype.initialize = function() {
    this.trigger('initialize');

    this.$element
      .addClass(this.settings.baseClass)
      .addClass(this.settings.themeClass)
      .toggleClass('owl-rtl', this.settings.rtl);

    // check support
    this.browserSupport();

    if (this.settings.autoWidth && this.state.imagesLoaded !== true) {
      var imgs, nestedSelector, width;
      imgs = this.$element.find('img');
      nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
      width = this.$element.children(nestedSelector).width();

      if (imgs.length && width <= 0) {
        this.preloadAutoWidthImages(imgs);
        return false;
      }
    }

    this.$element.addClass('owl-loading');

    // create stage
    this.$stage = $('<' + this.settings.stageElement + ' class="owl-stage"/>')
      .wrap('<div class="owl-stage-outer">');

    // append stage
    this.$element.append(this.$stage.parent());

    // append content
    this.replace(this.$element.children().not(this.$stage.parent()));

    // set view width
    this._width = this.$element.width();

    // update view
    this.refresh();

    this.$element.removeClass('owl-loading').addClass('owl-loaded');

    // attach generic events
    this.eventsCall();

    // attach generic events
    this.internalEvents();

    // attach custom control events
    this.addTriggerableEvents();

    this.trigger('initialized');
  };

  /**
   * Setups the current settings.
   * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
   * @todo Support for media queries by using `matchMedia` would be nice.
   * @public
   */
  Owl.prototype.setup = function() {
    var viewport = this.viewport(),
      overwrites = this.options.responsive,
      match = -1,
      settings = null;

    if (!overwrites) {
      settings = $.extend({}, this.options);
    } else {
      $.each(overwrites, function(breakpoint) {
        if (breakpoint <= viewport && breakpoint > match) {
          match = Number(breakpoint);
        }
      });

      settings = $.extend({}, this.options, overwrites[match]);
      delete settings.responsive;

      // responsive class
      if (settings.responsiveClass) {
        this.$element.attr('class', function(i, c) {
          return c.replace(/\b owl-responsive-\S+/g, '');
        }).addClass('owl-responsive-' + match);
      }
    }

    if (this.settings === null || this._breakpoint !== match) {
      this.trigger('change', {
        property: {
          name: 'settings',
          value: settings
        }
      });
      this._breakpoint = match;
      this.settings = settings;
      this.invalidate('settings');
      this.trigger('changed', {
        property: {
          name: 'settings',
          value: this.settings
        }
      });
    }
  };

  /**
   * Updates option logic if necessery.
   * @protected
   */
  Owl.prototype.optionsLogic = function() {
    // Toggle Center class
    this.$element.toggleClass('owl-center', this.settings.center);

    // if items number is less than in body
    if (this.settings.loop && this._items.length < this.settings.items) {
      this.settings.loop = false;
    }

    if (this.settings.autoWidth) {
      this.settings.stagePadding = false;
      this.settings.merge = false;
    }
  };

  /**
   * Prepares an item before add.
   * @todo Rename event parameter `content` to `item`.
   * @protected
   * @returns {jQuery|HTMLElement} - The item container.
   */
  Owl.prototype.prepare = function(item) {
    var event = this.trigger('prepare', {
      content: item
    });

    if (!event.data) {
      event.data = $('<' + this.settings.itemElement + '/>')
        .addClass(this.settings.itemClass).append(item)
    }

    this.trigger('prepared', {
      content: event.data
    });

    return event.data;
  };

  /**
   * Updates the view.
   * @public
   */
  Owl.prototype.update = function() {
    var i = 0,
      n = this._pipe.length,
      filter = $.proxy(function(p) {
        return this[p]
      }, this._invalidated),
      cache = {};

    while (i < n) {
      if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
        this._pipe[i].run(cache);
      }
      i++;
    }

    this._invalidated = {};
  };

  /**
   * Gets the width of the view.
   * @public
   * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
   * @returns {Number} - The width of the view in pixel.
   */
  Owl.prototype.width = function(dimension) {
    dimension = dimension || Owl.Width.Default;
    switch (dimension) {
      case Owl.Width.Inner:
      case Owl.Width.Outer:
        return this._width;
      default:
        return this._width - this.settings.stagePadding * 2 + this.settings.margin;
    }
  };

  /**
   * Refreshes the carousel primarily for adaptive purposes.
   * @public
   */
  Owl.prototype.refresh = function() {
    if (this._items.length === 0) {
      return false;
    }

    var start = new Date().getTime();

    this.trigger('refresh');

    this.setup();

    this.optionsLogic();

    // hide and show methods helps here to set a proper widths,
    // this prevents scrollbar to be calculated in stage width
    this.$stage.addClass('owl-refresh');

    this.update();

    this.$stage.removeClass('owl-refresh');

    this.state.orientation = window.orientation;

    this.watchVisibility();

    this.trigger('refreshed');
  };

  /**
   * Save internal event references and add event based functions.
   * @protected
   */
  Owl.prototype.eventsCall = function() {
    // Save events references
    this.e._onDragStart = $.proxy(function(e) {
      this.onDragStart(e);
    }, this);
    this.e._onDragMove = $.proxy(function(e) {
      this.onDragMove(e);
    }, this);
    this.e._onDragEnd = $.proxy(function(e) {
      this.onDragEnd(e);
    }, this);
    this.e._onResize = $.proxy(function(e) {
      this.onResize(e);
    }, this);
    this.e._transitionEnd = $.proxy(function(e) {
      this.transitionEnd(e);
    }, this);
    this.e._preventClick = $.proxy(function(e) {
      this.preventClick(e);
    }, this);
  };

  /**
   * Checks window `resize` event.
   * @protected
   */
  Owl.prototype.onThrottledResize = function() {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(this.e._onResize, this.settings.responsiveRefreshRate);
  };

  /**
   * Checks window `resize` event.
   * @protected
   */
  Owl.prototype.onResize = function() {
    if (!this._items.length) {
      return false;
    }

    if (this._width === this.$element.width()) {
      return false;
    }

    if (this.trigger('resize').isDefaultPrevented()) {
      return false;
    }

    this._width = this.$element.width();

    this.invalidate('width');

    this.refresh();

    this.trigger('resized');
  };

  /**
   * Checks for touch/mouse drag event type and add run event handlers.
   * @protected
   */
  Owl.prototype.eventsRouter = function(event) {
    var type = event.type;

    if (type === "mousedown" || type === "touchstart") {
      this.onDragStart(event);
    } else if (type === "mousemove" || type === "touchmove") {
      this.onDragMove(event);
    } else if (type === "mouseup" || type === "touchend") {
      this.onDragEnd(event);
    } else if (type === "touchcancel") {
      this.onDragEnd(event);
    }
  };

  /**
   * Checks for touch/mouse drag options and add necessery event handlers.
   * @protected
   */
  Owl.prototype.internalEvents = function() {
    var isTouch = isTouchSupport(),
      isTouchIE = isTouchSupportIE();

    if (this.settings.mouseDrag) {
      this.$stage.on('mousedown', $.proxy(function(event) {
        this.eventsRouter(event)
      }, this));
      this.$stage.on('dragstart', function() {
        return false
      });
      this.$stage.get(0).onselectstart = function() {
        return false
      };
    } else {
      this.$element.addClass('owl-text-select-on');
    }

    if (this.settings.touchDrag && !isTouchIE) {
      this.$stage.on('touchstart touchcancel', $.proxy(function(event) {
        this.eventsRouter(event)
      }, this));
    }

    // catch transitionEnd event
    if (this.transitionEndVendor) {
      this.on(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd, false);
    }

    // responsive
    if (this.settings.responsive !== false) {
      this.on(window, 'resize', $.proxy(this.onThrottledResize, this));
    }
  };

  /**
   * Handles touchstart/mousedown event.
   * @protected
   * @param {Event} event - The event arguments.
   */
  Owl.prototype.onDragStart = function(event) {
    var ev, isTouchEvent, pageX, pageY, animatedPos;

    ev = event.originalEvent || event || window.event;

    // prevent right click
    if (ev.which === 3 || this.state.isTouch) {
      return false;
    }

    if (ev.type === 'mousedown') {
      this.$stage.addClass('owl-grab');
    }

    this.trigger('drag');
    this.drag.startTime = new Date().getTime();
    this.speed(0);
    this.state.isTouch = true;
    this.state.isScrolling = false;
    this.state.isSwiping = false;
    this.drag.distance = 0;

    pageX = getTouches(ev).x;
    pageY = getTouches(ev).y;

    // get stage position left
    this.drag.offsetX = this.$stage.position().left;
    this.drag.offsetY = this.$stage.position().top;

    if (this.settings.rtl) {
      this.drag.offsetX = this.$stage.position().left + this.$stage.width() - this.width() +
        this.settings.margin;
    }

    // catch position // ie to fix
    if (this.state.inMotion && this.support3d) {
      animatedPos = this.getTransformProperty();
      this.drag.offsetX = animatedPos;
      this.animate(animatedPos);
      this.state.inMotion = true;
    } else if (this.state.inMotion && !this.support3d) {
      this.state.inMotion = false;
      return false;
    }

    this.drag.startX = pageX - this.drag.offsetX;
    this.drag.startY = pageY - this.drag.offsetY;

    this.drag.start = pageX - this.drag.startX;
    this.drag.targetEl = ev.target || ev.srcElement;
    this.drag.updatedX = this.drag.start;

    // to do/check
    // prevent links and images dragging;
    if (this.drag.targetEl.tagName === "IMG" || this.drag.targetEl.tagName === "A") {
      this.drag.targetEl.draggable = false;
    }

    $(document).on('mousemove.owl.dragEvents mouseup.owl.dragEvents touchmove.owl.dragEvents touchend.owl.dragEvents', $.proxy(function(event) {
      this.eventsRouter(event)
    }, this));
  };

  /**
   * Handles the touchmove/mousemove events.
   * @todo Simplify
   * @protected
   * @param {Event} event - The event arguments.
   */
  Owl.prototype.onDragMove = function(event) {
    var ev, isTouchEvent, pageX, pageY, minValue, maxValue, pull;

    if (!this.state.isTouch) {
      return;
    }

    if (this.state.isScrolling) {
      return;
    }

    ev = event.originalEvent || event || window.event;

    pageX = getTouches(ev).x;
    pageY = getTouches(ev).y;

    // Drag Direction
    this.drag.currentX = pageX - this.drag.startX;
    this.drag.currentY = pageY - this.drag.startY;
    this.drag.distance = this.drag.currentX - this.drag.offsetX;

    // Check move direction
    if (this.drag.distance < 0) {
      this.state.direction = this.settings.rtl ? 'right' : 'left';
    } else if (this.drag.distance > 0) {
      this.state.direction = this.settings.rtl ? 'left' : 'right';
    }
    // Loop
    if (this.settings.loop) {
      if (this.op(this.drag.currentX, '>', this.coordinates(this.minimum())) && this.state.direction === 'right') {
        this.drag.currentX -= (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length);
      } else if (this.op(this.drag.currentX, '<', this.coordinates(this.maximum())) && this.state.direction === 'left') {
        this.drag.currentX += (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length);
      }
    } else {
      // pull
      minValue = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
      maxValue = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
      pull = this.settings.pullDrag ? this.drag.distance / 5 : 0;
      this.drag.currentX = Math.max(Math.min(this.drag.currentX, minValue + pull), maxValue + pull);
    }

    // Lock browser if swiping horizontal

    if ((this.drag.distance > 8 || this.drag.distance < -8)) {
      if (ev.preventDefault !== undefined) {
        ev.preventDefault();
      } else {
        ev.returnValue = false;
      }
      this.state.isSwiping = true;
    }

    this.drag.updatedX = this.drag.currentX;

    // Lock Owl if scrolling
    if ((this.drag.currentY > 16 || this.drag.currentY < -16) && this.state.isSwiping === false) {
      this.state.isScrolling = true;
      this.drag.updatedX = this.drag.start;
    }

    this.animate(this.drag.updatedX);
  };

  /**
   * Handles the touchend/mouseup events.
   * @protected
   */
  Owl.prototype.onDragEnd = function(event) {
    var compareTimes, distanceAbs, closest;

    if (!this.state.isTouch) {
      return;
    }

    if (event.type === 'mouseup') {
      this.$stage.removeClass('owl-grab');
    }

    this.trigger('dragged');

    // prevent links and images dragging;
    this.drag.targetEl.removeAttribute("draggable");

    // remove drag event listeners

    this.state.isTouch = false;
    this.state.isScrolling = false;
    this.state.isSwiping = false;

    // to check
    if (this.drag.distance === 0 && this.state.inMotion !== true) {
      this.state.inMotion = false;
      return false;
    }

    // prevent clicks while scrolling

    this.drag.endTime = new Date().getTime();
    compareTimes = this.drag.endTime - this.drag.startTime;
    distanceAbs = Math.abs(this.drag.distance);

    // to test
    if (distanceAbs > 3 || compareTimes > 300) {
      this.removeClick(this.drag.targetEl);
    }

    closest = this.closest(this.drag.updatedX);

    this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
    this.current(closest);
    this.invalidate('position');
    this.update();

    // if pullDrag is off then fire transitionEnd event manually when stick
    // to border
    if (!this.settings.pullDrag && this.drag.updatedX === this.coordinates(closest)) {
      this.transitionEnd();
    }

    this.drag.distance = 0;

    $(document).off('.owl.dragEvents');
  };

  /**
   * Attaches `preventClick` to disable link while swipping.
   * @protected
   * @param {HTMLElement} [target] - The target of the `click` event.
   */
  Owl.prototype.removeClick = function(target) {
    this.drag.targetEl = target;
    $(target).on('click.preventClick', this.e._preventClick);
    // to make sure click is removed:
    window.setTimeout(function() {
      $(target).off('click.preventClick');
    }, 300);
  };

  /**
   * Suppresses click event.
   * @protected
   * @param {Event} ev - The event arguments.
   */
  Owl.prototype.preventClick = function(ev) {
    if (ev.preventDefault) {
      ev.preventDefault();
    } else {
      ev.returnValue = false;
    }
    if (ev.stopPropagation) {
      ev.stopPropagation();
    }
    $(ev.target).off('click.preventClick');
  };

  /**
   * Catches stage position while animate (only CSS3).
   * @protected
   * @returns
   */
  Owl.prototype.getTransformProperty = function() {
    var transform, matrix3d;

    transform = window.getComputedStyle(this.$stage.get(0), null).getPropertyValue(this.vendorName + 'transform');
    // var transform = this.$stage.css(this.vendorName + 'transform')
    transform = transform.replace(/matrix(3d)?\(|\)/g, '').split(',');
    matrix3d = transform.length === 16;

    return matrix3d !== true ? transform[4] : transform[12];
  };

  /**
   * Gets absolute position of the closest item for a coordinate.
   * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
   * @protected
   * @param {Number} coordinate - The coordinate in pixel.
   * @return {Number} - The absolute position of the closest item.
   */
  Owl.prototype.closest = function(coordinate) {
    var position = -1,
      pull = 30,
      width = this.width(),
      coordinates = this.coordinates();

    if (!this.settings.freeDrag) {
      // check closest item
      $.each(coordinates, $.proxy(function(index, value) {
        if (coordinate > value - pull && coordinate < value + pull) {
          position = index;
        } else if (this.op(coordinate, '<', value) &&
          this.op(coordinate, '>', coordinates[index + 1] || value - width)) {
          position = this.state.direction === 'left' ? index + 1 : index;
        }
        return position === -1;
      }, this));
    }

    if (!this.settings.loop) {
      // non loop boundries
      if (this.op(coordinate, '>', coordinates[this.minimum()])) {
        position = coordinate = this.minimum();
      } else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
        position = coordinate = this.maximum();
      }
    }

    return position;
  };

  /**
   * Animates the stage.
   * @public
   * @param {Number} coordinate - The coordinate in pixels.
   */
  Owl.prototype.animate = function(coordinate) {
    this.trigger('translate');
    this.state.inMotion = this.speed() > 0;

    if (this.support3d) {
      this.$stage.css({
        transform: 'translate3d(' + coordinate + 'px' + ',0px, 0px)',
        transition: (this.speed() / 1000) + 's'
      });
    } else if (this.state.isTouch) {
      this.$stage.css({
        left: coordinate + 'px'
      });
    } else {
      this.$stage.animate({
        left: coordinate
      }, this.speed() / 1000, this.settings.fallbackEasing, $.proxy(function() {
        if (this.state.inMotion) {
          this.transitionEnd();
        }
      }, this));
    }
  };

  /**
   * Sets the absolute position of the current item.
   * @public
   * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
   * @returns {Number} - The absolute position of the current item.
   */
  Owl.prototype.current = function(position) {
    if (position === undefined) {
      return this._current;
    }

    if (this._items.length === 0) {
      return undefined;
    }

    position = this.normalize(position);

    if (this._current !== position) {
      var event = this.trigger('change', {
        property: {
          name: 'position',
          value: position
        }
      });

      if (event.data !== undefined) {
        position = this.normalize(event.data);
      }

      this._current = position;

      this.invalidate('position');

      this.trigger('changed', {
        property: {
          name: 'position',
          value: this._current
        }
      });
    }

    return this._current;
  };

  /**
   * Invalidates the given part of the update routine.
   * @param {String} part - The part to invalidate.
   */
  Owl.prototype.invalidate = function(part) {
    this._invalidated[part] = true;
  }

  /**
   * Resets the absolute position of the current item.
   * @public
   * @param {Number} position - The absolute position of the new item.
   */
  Owl.prototype.reset = function(position) {
    position = this.normalize(position);

    if (position === undefined) {
      return;
    }

    this._speed = 0;
    this._current = position;

    this.suppress(['translate', 'translated']);

    this.animate(this.coordinates(position));

    this.release(['translate', 'translated']);
  };

  /**
   * Normalizes an absolute or a relative position for an item.
   * @public
   * @param {Number} position - The absolute or relative position to normalize.
   * @param {Boolean} [relative=false] - Whether the given position is relative or not.
   * @returns {Number} - The normalized position.
   */
  Owl.prototype.normalize = function(position, relative) {
    var n = (relative ? this._items.length : this._items.length + this._clones.length);

    if (!$.isNumeric(position) || n < 1) {
      return undefined;
    }

    if (this._clones.length) {
      position = ((position % n) + n) % n;
    } else {
      position = Math.max(this.minimum(relative), Math.min(this.maximum(relative), position));
    }

    return position;
  };

  /**
   * Converts an absolute position for an item into a relative position.
   * @public
   * @param {Number} position - The absolute position to convert.
   * @returns {Number} - The converted position.
   */
  Owl.prototype.relative = function(position) {
    position = this.normalize(position);
    position = position - this._clones.length / 2;
    return this.normalize(position, true);
  };

  /**
   * Gets the maximum position for an item.
   * @public
   * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
   * @returns {Number}
   */
  Owl.prototype.maximum = function(relative) {
    var maximum, width, i = 0,
      coordinate,
      settings = this.settings;

    if (relative) {
      return this._items.length - 1;
    }

    if (!settings.loop && settings.center) {
      maximum = this._items.length - 1;
    } else if (!settings.loop && !settings.center) {
      maximum = this._items.length - settings.items;
    } else if (settings.loop || settings.center) {
      maximum = this._items.length + settings.items;
    } else if (settings.autoWidth || settings.merge) {
      revert = settings.rtl ? 1 : -1;
      width = this.$stage.width() - this.$element.width();
      while (coordinate = this.coordinates(i)) {
        if (coordinate * revert >= width) {
          break;
        }
        maximum = ++i;
      }
    } else {
      throw 'Can not detect maximum absolute position.'
    }

    return maximum;
  };

  /**
   * Gets the minimum position for an item.
   * @public
   * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
   * @returns {Number}
   */
  Owl.prototype.minimum = function(relative) {
    if (relative) {
      return 0;
    }

    return this._clones.length / 2;
  };

  /**
   * Gets an item at the specified relative position.
   * @public
   * @param {Number} [position] - The relative position of the item.
   * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
   */
  Owl.prototype.items = function(position) {
    if (position === undefined) {
      return this._items.slice();
    }

    position = this.normalize(position, true);
    return this._items[position];
  };

  /**
   * Gets an item at the specified relative position.
   * @public
   * @param {Number} [position] - The relative position of the item.
   * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
   */
  Owl.prototype.mergers = function(position) {
    if (position === undefined) {
      return this._mergers.slice();
    }

    position = this.normalize(position, true);
    return this._mergers[position];
  };

  /**
   * Gets the absolute positions of clones for an item.
   * @public
   * @param {Number} [position] - The relative position of the item.
   * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
   */
  Owl.prototype.clones = function(position) {
    var odd = this._clones.length / 2,
      even = odd + this._items.length,
      map = function(index) {
        return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2
      };

    if (position === undefined) {
      return $.map(this._clones, function(v, i) {
        return map(i)
      });
    }

    return $.map(this._clones, function(v, i) {
      return v === position ? map(i) : null
    });
  };

  /**
   * Sets the current animation speed.
   * @public
   * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
   * @returns {Number} - The current animation speed in milliseconds.
   */
  Owl.prototype.speed = function(speed) {
    if (speed !== undefined) {
      this._speed = speed;
    }

    return this._speed;
  };

  /**
   * Gets the coordinate of an item.
   * @todo The name of this method is missleanding.
   * @public
   * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
   * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
   */
  Owl.prototype.coordinates = function(position) {
    var coordinate = null;

    if (position === undefined) {
      return $.map(this._coordinates, $.proxy(function(coordinate, index) {
        return this.coordinates(index);
      }, this));
    }

    if (this.settings.center) {
      coordinate = this._coordinates[position];
      coordinate += (this.width() - coordinate + (this._coordinates[position - 1] || 0)) / 2 * (this.settings.rtl ? -1 : 1);
    } else {
      coordinate = this._coordinates[position - 1] || 0;
    }

    return coordinate;
  };

  /**
   * Calculates the speed for a translation.
   * @protected
   * @param {Number} from - The absolute position of the start item.
   * @param {Number} to - The absolute position of the target item.
   * @param {Number} [factor=undefined] - The time factor in milliseconds.
   * @returns {Number} - The time in milliseconds for the translation.
   */
  Owl.prototype.duration = function(from, to, factor) {
    return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
  };

  /**
   * Slides to the specified item.
   * @public
   * @param {Number} position - The position of the item.
   * @param {Number} [speed] - The time in milliseconds for the transition.
   */
  Owl.prototype.to = function(position, speed) {
    if (this.settings.loop) {
      var distance = position - this.relative(this.current()),
        revert = this.current(),
        before = this.current(),
        after = this.current() + distance,
        direction = before - after < 0 ? true : false,
        items = this._clones.length + this._items.length;

      if (after < this.settings.items && direction === false) {
        revert = before + this._items.length;
        this.reset(revert);
      } else if (after >= items - this.settings.items && direction === true) {
        revert = before - this._items.length;
        this.reset(revert);
      }
      window.clearTimeout(this.e._goToLoop);
      this.e._goToLoop = window.setTimeout($.proxy(function() {
        this.speed(this.duration(this.current(), revert + distance, speed));
        this.current(revert + distance);
        this.update();
      }, this), 30);
    } else {
      this.speed(this.duration(this.current(), position, speed));
      this.current(position);
      this.update();
    }
  };

  /**
   * Slides to the next item.
   * @public
   * @param {Number} [speed] - The time in milliseconds for the transition.
   */
  Owl.prototype.next = function(speed) {
    speed = speed || false;
    this.to(this.relative(this.current()) + 1, speed);
  };

  /**
   * Slides to the previous item.
   * @public
   * @param {Number} [speed] - The time in milliseconds for the transition.
   */
  Owl.prototype.prev = function(speed) {
    speed = speed || false;
    this.to(this.relative(this.current()) - 1, speed);
  };

  /**
   * Handles the end of an animation.
   * @protected
   * @param {Event} event - The event arguments.
   */
  Owl.prototype.transitionEnd = function(event) {

    // if css2 animation then event object is undefined
    if (event !== undefined) {
      event.stopPropagation();

      // Catch only owl-stage transitionEnd event
      if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
        return false;
      }
    }

    this.state.inMotion = false;
    this.trigger('translated');
  };

  /**
   * Gets viewport width.
   * @protected
   * @return {Number} - The width in pixel.
   */
  Owl.prototype.viewport = function() {
    var width;
    if (this.options.responsiveBaseElement !== window) {
      width = $(this.options.responsiveBaseElement).width();
    } else if (window.innerWidth) {
      width = window.innerWidth;
    } else if (document.documentElement && document.documentElement.clientWidth) {
      width = document.documentElement.clientWidth;
    } else {
      throw 'Can not detect viewport width.';
    }
    return width;
  };

  /**
   * Replaces the current content.
   * @public
   * @param {HTMLElement|jQuery|String} content - The new content.
   */
  Owl.prototype.replace = function(content) {
    this.$stage.empty();
    this._items = [];

    if (content) {
      content = (content instanceof jQuery) ? content : $(content);
    }

    if (this.settings.nestedItemSelector) {
      content = content.find('.' + this.settings.nestedItemSelector);
    }

    content.filter(function() {
      return this.nodeType === 1;
    }).each($.proxy(function(index, item) {
      item = this.prepare(item);
      this.$stage.append(item);
      this._items.push(item);
      this._mergers.push(item.find('[data-merge]').andSelf('[data-merge]').attr('data-merge') * 1 || 1);
    }, this));

    this.reset($.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);

    this.invalidate('items');
  };

  /**
   * Adds an item.
   * @todo Use `item` instead of `content` for the event arguments.
   * @public
   * @param {HTMLElement|jQuery|String} content - The item content to add.
   * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
   */
  Owl.prototype.add = function(content, position) {
    position = position === undefined ? this._items.length : this.normalize(position, true);

    this.trigger('add', {
      content: content,
      position: position
    });

    if (this._items.length === 0 || position === this._items.length) {
      this.$stage.append(content);
      this._items.push(content);
      this._mergers.push(content.find('[data-merge]').andSelf('[data-merge]').attr('data-merge') * 1 || 1);
    } else {
      this._items[position].before(content);
      this._items.splice(position, 0, content);
      this._mergers.splice(position, 0, content.find('[data-merge]').andSelf('[data-merge]').attr('data-merge') * 1 || 1);
    }

    this.invalidate('items');

    this.trigger('added', {
      content: content,
      position: position
    });
  };

  /**
   * Removes an item by its position.
   * @todo Use `item` instead of `content` for the event arguments.
   * @public
   * @param {Number} position - The relative position of the item to remove.
   */
  Owl.prototype.remove = function(position) {
    position = this.normalize(position, true);

    if (position === undefined) {
      return;
    }

    this.trigger('remove', {
      content: this._items[position],
      position: position
    });

    this._items[position].remove();
    this._items.splice(position, 1);
    this._mergers.splice(position, 1);

    this.invalidate('items');

    this.trigger('removed', {
      content: null,
      position: position
    });
  };

  /**
   * Adds triggerable events.
   * @protected
   */
  Owl.prototype.addTriggerableEvents = function() {
    var handler = $.proxy(function(callback, event) {
      return $.proxy(function(e) {
        if (e.relatedTarget !== this) {
          this.suppress([event]);
          callback.apply(this, [].slice.call(arguments, 1));
          this.release([event]);
        }
      }, this);
    }, this);

    $.each({
      'next': this.next,
      'prev': this.prev,
      'to': this.to,
      'destroy': this.destroy,
      'refresh': this.refresh,
      'replace': this.replace,
      'add': this.add,
      'remove': this.remove
    }, $.proxy(function(event, callback) {
      this.$element.on(event + '.owl.carousel', handler(callback, event + '.owl.carousel'));
    }, this));

  };

  /**
   * Watches the visibility of the carousel element.
   * @protected
   */
  Owl.prototype.watchVisibility = function() {

    // test on zepto
    if (!isElVisible(this.$element.get(0))) {
      this.$element.addClass('owl-hidden');
      window.clearInterval(this.e._checkVisibile);
      this.e._checkVisibile = window.setInterval($.proxy(checkVisible, this), 500);
    }

    function isElVisible(el) {
      return el.offsetWidth > 0 && el.offsetHeight > 0;
    }

    function checkVisible() {
      if (isElVisible(this.$element.get(0))) {
        this.$element.removeClass('owl-hidden');
        this.refresh();
        window.clearInterval(this.e._checkVisibile);
      }
    }
  };

  /**
   * Preloads images with auto width.
   * @protected
   * @todo Still to test
   */
  Owl.prototype.preloadAutoWidthImages = function(imgs) {
    var loaded, that, $el, img;

    loaded = 0;
    that = this;
    imgs.each(function(i, el) {
      $el = $(el);
      img = new Image();

      img.onload = function() {
        loaded++;
        $el.attr('src', img.src);
        $el.css('opacity', 1);
        if (loaded >= imgs.length) {
          that.state.imagesLoaded = true;
          that.initialize();
        }
      };

      img.src = $el.attr('src') || $el.attr('data-src') || $el.attr('data-src-retina');
    });
  };

  /**
   * Destroys the carousel.
   * @public
   */
  Owl.prototype.destroy = function() {

    if (this.$element.hasClass(this.settings.themeClass)) {
      this.$element.removeClass(this.settings.themeClass);
    }

    if (this.settings.responsive !== false) {
      $(window).off('resize.owl.carousel');
    }

    if (this.transitionEndVendor) {
      this.off(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd);
    }

    for (var i in this._plugins) {
      this._plugins[i].destroy();
    }

    if (this.settings.mouseDrag || this.settings.touchDrag) {
      this.$stage.off('mousedown touchstart touchcancel');
      $(document).off('.owl.dragEvents');
      this.$stage.get(0).onselectstart = function() {};
      this.$stage.off('dragstart', function() {
        return false
      });
    }

    // remove event handlers in the ".owl.carousel" namespace
    this.$element.off('.owl');

    this.$stage.children('.cloned').remove();
    this.e = null;
    this.$element.removeData('owlCarousel');

    this.$stage.children().contents().unwrap();
    this.$stage.children().unwrap();
    this.$stage.unwrap();
  };

  /**
   * Operators to calculate right-to-left and left-to-right.
   * @protected
   * @param {Number} [a] - The left side operand.
   * @param {String} [o] - The operator.
   * @param {Number} [b] - The right side operand.
   */
  Owl.prototype.op = function(a, o, b) {
    var rtl = this.settings.rtl;
    switch (o) {
      case '<':
        return rtl ? a > b : a < b;
      case '>':
        return rtl ? a < b : a > b;
      case '>=':
        return rtl ? a <= b : a >= b;
      case '<=':
        return rtl ? a >= b : a <= b;
      default:
        break;
    }
  };

  /**
   * Attaches to an internal event.
   * @protected
   * @param {HTMLElement} element - The event source.
   * @param {String} event - The event name.
   * @param {Function} listener - The event handler to attach.
   * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
   */
  Owl.prototype.on = function(element, event, listener, capture) {
    if (element.addEventListener) {
      element.addEventListener(event, listener, capture);
    } else if (element.attachEvent) {
      element.attachEvent('on' + event, listener);
    }
  };

  /**
   * Detaches from an internal event.
   * @protected
   * @param {HTMLElement} element - The event source.
   * @param {String} event - The event name.
   * @param {Function} listener - The attached event handler to detach.
   * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
   */
  Owl.prototype.off = function(element, event, listener, capture) {
    if (element.removeEventListener) {
      element.removeEventListener(event, listener, capture);
    } else if (element.detachEvent) {
      element.detachEvent('on' + event, listener);
    }
  };

  /**
   * Triggers an public event.
   * @protected
   * @param {String} name - The event name.
   * @param {*} [data=null] - The event data.
   * @param {String} [namespace=.owl.carousel] - The event namespace.
   * @returns {Event} - The event arguments.
   */
  Owl.prototype.trigger = function(name, data, namespace) {
    var status = {
        item: {
          count: this._items.length,
          index: this.current()
        }
      },
      handler = $.camelCase(
        $.grep(['on', name, namespace], function(v) {
          return v
        })
        .join('-').toLowerCase()
      ),
      event = $.Event(
        [name, 'owl', namespace || 'carousel'].join('.').toLowerCase(),
        $.extend({
          relatedTarget: this
        }, status, data)
      );

    if (!this._supress[name]) {
      $.each(this._plugins, function(name, plugin) {
        if (plugin.onTrigger) {
          plugin.onTrigger(event);
        }
      });

      this.$element.trigger(event);

      if (this.settings && typeof this.settings[handler] === 'function') {
        this.settings[handler].apply(this, event);
      }
    }

    return event;
  };

  /**
   * Suppresses events.
   * @protected
   * @param {Array.<String>} events - The events to suppress.
   */
  Owl.prototype.suppress = function(events) {
    $.each(events, $.proxy(function(index, event) {
      this._supress[event] = true;
    }, this));
  }

  /**
   * Releases suppressed events.
   * @protected
   * @param {Array.<String>} events - The events to release.
   */
  Owl.prototype.release = function(events) {
    $.each(events, $.proxy(function(index, event) {
      delete this._supress[event];
    }, this));
  }

  /**
   * Checks the availability of some browser features.
   * @protected
   */
  Owl.prototype.browserSupport = function() {
    this.support3d = isPerspective();

    if (this.support3d) {
      this.transformVendor = isTransform();

      // take transitionend event name by detecting transition
      var endVendors = ['transitionend', 'webkitTransitionEnd', 'transitionend', 'oTransitionEnd'];
      this.transitionEndVendor = endVendors[isTransition()];

      // take vendor name from transform name
      this.vendorName = this.transformVendor.replace(/Transform/i, '');
      this.vendorName = this.vendorName !== '' ? '-' + this.vendorName.toLowerCase() + '-' : '';
    }

    this.state.orientation = window.orientation;
  };

  /**
   * Get touch/drag coordinats.
   * @private
   * @param {event} - mousedown/touchstart event
   * @returns {object} - Contains X and Y of current mouse/touch position
   */

  function getTouches(event) {
    if (event.touches !== undefined) {
      return {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
      };
    }

    if (event.touches === undefined) {
      if (event.pageX !== undefined) {
        return {
          x: event.pageX,
          y: event.pageY
        };
      }

      if (event.pageX === undefined) {
        return {
          x: event.clientX,
          y: event.clientY
        };
      }
    }
  }

  /**
   * Checks for CSS support.
   * @private
   * @param {Array} array - The CSS properties to check for.
   * @returns {Array} - Contains the supported CSS property name and its index or `false`.
   */
  function isStyleSupported(array) {
    var p, s, fake = document.createElement('div'),
      list = array;
    for (p in list) {
      s = list[p];
      if (typeof fake.style[s] !== 'undefined') {
        fake = null;
        return [s, p];
      }
    }
    return [false];
  }

  /**
   * Checks for CSS transition support.
   * @private
   * @todo Realy bad design
   * @returns {Number}
   */
  function isTransition() {
    return isStyleSupported(['transition', 'WebkitTransition', 'MozTransition', 'OTransition'])[1];
  }

  /**
   * Checks for CSS transform support.
   * @private
   * @returns {String} The supported property name or false.
   */
  function isTransform() {
    return isStyleSupported(['transform', 'WebkitTransform', 'MozTransform', 'OTransform', 'msTransform'])[0];
  }

  /**
   * Checks for CSS perspective support.
   * @private
   * @returns {String} The supported property name or false.
   */
  function isPerspective() {
    return isStyleSupported(['perspective', 'webkitPerspective', 'MozPerspective', 'OPerspective', 'MsPerspective'])[0];
  }

  /**
   * Checks wether touch is supported or not.
   * @private
   * @returns {Boolean}
   */
  function isTouchSupport() {
    return 'ontouchstart' in window || !!(navigator.msMaxTouchPoints);
  }

  /**
   * Checks wether touch is supported or not for IE.
   * @private
   * @returns {Boolean}
   */
  function isTouchSupportIE() {
    return window.navigator.msPointerEnabled;
  }

  /**
   * The jQuery Plugin for the Owl Carousel
   * @public
   */
  $.fn.owlCarousel = function(options) {
    return this.each(function() {
      if (!$(this).data('owlCarousel')) {
        $(this).data('owlCarousel', new Owl(this, options));
      }
    });
  };

  /**
   * The constructor for the jQuery Plugin
   * @public
   */
  $.fn.owlCarousel.Constructor = Owl;

})(window.Zepto || window.jQuery, window, document);

/**
 * Lazy Plugin
 * @version 2.0.0
 * @author Bartosz Wojciechowski
 * @license The MIT License (MIT)
 */
;
(function($, window, document, undefined) {

  /**
   * Creates the lazy plugin.
   * @class The Lazy Plugin
   * @param {Owl} carousel - The Owl Carousel
   */
  var Lazy = function(carousel) {

    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * Already loaded items.
     * @protected
     * @type {Array.<jQuery>}
     */
    this._loaded = [];

    /**
     * Event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'initialized.owl.carousel change.owl.carousel': $.proxy(function(e) {
        if (!e.namespace) {
          return;
        }

        if (!this._core.settings || !this._core.settings.lazyLoad) {
          return;
        }

        if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
          var settings = this._core.settings,
            n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
            i = ((settings.center && n * -1) || 0),
            position = ((e.property && e.property.value) || this._core.current()) + i,
            clones = this._core.clones().length,
            load = $.proxy(function(i, v) {
              this.load(v)
            }, this);

          while (i++ < n) {
            this.load(clones / 2 + this._core.relative(position));
            clones && $.each(this._core.clones(this._core.relative(position++)), load);
          }
        }
      }, this)
    };

    // set the default options
    this._core.options = $.extend({}, Lazy.Defaults, this._core.options);

    // register event handler
    this._core.$element.on(this._handlers);
  }

  /**
   * Default options.
   * @public
   */
  Lazy.Defaults = {
    lazyLoad: false
  }

  /**
   * Loads all resources of an item at the specified position.
   * @param {Number} position - The absolute position of the item.
   * @protected
   */
  Lazy.prototype.load = function(position) {
    var $item = this._core.$stage.children().eq(position),
      $elements = $item && $item.find('.owl-lazy');

    if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
      return;
    }

    $elements.each($.proxy(function(index, element) {
      var $element = $(element),
        image,
        url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src');

      this._core.trigger('load', {
        element: $element,
        url: url
      }, 'lazy');

      if ($element.is('img')) {
        $element.one('load.owl.lazy', $.proxy(function() {
          $element.css('opacity', 1);
          this._core.trigger('loaded', {
            element: $element,
            url: url
          }, 'lazy');
        }, this)).attr('src', url);
      } else {
        image = new Image();
        image.onload = $.proxy(function() {
          $element.css({
            'background-image': 'url(' + url + ')',
            'opacity': '1'
          });
          this._core.trigger('loaded', {
            element: $element,
            url: url
          }, 'lazy');
        }, this);
        image.src = url;
      }
    }, this));

    this._loaded.push($item.get(0));
  }

  /**
   * Destroys the plugin.
   * @public
   */
  Lazy.prototype.destroy = function() {
    var handler, property;

    for (handler in this.handlers) {
      this._core.$element.off(handler, this.handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  }

  $.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;

})(window.Zepto || window.jQuery, window, document);

/**
 * AutoHeight Plugin
 * @version 2.0.0
 * @author Bartosz Wojciechowski
 * @license The MIT License (MIT)
 */
;
(function($, window, document, undefined) {

  /**
   * Creates the auto height plugin.
   * @class The Auto Height Plugin
   * @param {Owl} carousel - The Owl Carousel
   */
  var AutoHeight = function(carousel) {
    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * All event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'initialized.owl.carousel': $.proxy(function() {
        if (this._core.settings.autoHeight) {
          this.update();
        }
      }, this),
      'changed.owl.carousel': $.proxy(function(e) {
        if (this._core.settings.autoHeight && e.property.name == 'position') {
          this.update();
        }
      }, this),
      'loaded.owl.lazy': $.proxy(function(e) {
        if (this._core.settings.autoHeight && e.element.closest('.' + this._core.settings.itemClass) ===
          this._core.$stage.children().eq(this._core.current())) {
          this.update();
        }
      }, this)
    };

    // set default options
    this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

    // register event handlers
    this._core.$element.on(this._handlers);
  };

  /**
   * Default options.
   * @public
   */
  AutoHeight.Defaults = {
    autoHeight: false,
    autoHeightClass: 'owl-height'
  };

  /**
   * Updates the view.
   */
  AutoHeight.prototype.update = function() {
    this._core.$stage.parent()
      .height(this._core.$stage.children().eq(this._core.current()).height())
      .addClass(this._core.settings.autoHeightClass);
  };

  AutoHeight.prototype.destroy = function() {
    var handler, property;

    for (handler in this._handlers) {
      this._core.$element.off(handler, this._handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;

})(window.Zepto || window.jQuery, window, document);

/**
 * Video Plugin
 * @version 2.0.0
 * @author Bartosz Wojciechowski
 * @license The MIT License (MIT)
 */
;
(function($, window, document, undefined) {

  /**
   * Creates the video plugin.
   * @class The Video Plugin
   * @param {Owl} carousel - The Owl Carousel
   */
  var Video = function(carousel) {
    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * Cache all video URLs.
     * @protected
     * @type {Object}
     */
    this._videos = {};

    /**
     * Current playing item.
     * @protected
     * @type {jQuery}
     */
    this._playing = null;

    /**
     * Whether this is in fullscreen or not.
     * @protected
     * @type {Boolean}
     */
    this._fullscreen = false;

    /**
     * All event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'resize.owl.carousel': $.proxy(function(e) {
        if (this._core.settings.video && !this.isInFullScreen()) {
          e.preventDefault();
        }
      }, this),
      'refresh.owl.carousel changed.owl.carousel': $.proxy(function(e) {
        if (this._playing) {
          this.stop();
        }
      }, this),
      'prepared.owl.carousel': $.proxy(function(e) {
        var $element = $(e.content).find('.owl-video');
        if ($element.length) {
          $element.css('display', 'none');
          this.fetch($element, $(e.content));
        }
      }, this)
    };

    // set default options
    this._core.options = $.extend({}, Video.Defaults, this._core.options);

    // register event handlers
    this._core.$element.on(this._handlers);

    this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
      this.play(e);
    }, this));
  };

  /**
   * Default options.
   * @public
   */
  Video.Defaults = {
    video: false,
    videoHeight: false,
    videoWidth: false
  };

  /**
   * Gets the video ID and the type (YouTube/Vimeo only).
   * @protected
   * @param {jQuery} target - The target containing the video data.
   * @param {jQuery} item - The item containing the video.
   */
  Video.prototype.fetch = function(target, item) {

    var type = target.attr('data-vimeo-id') ? 'vimeo' : 'youtube',
      id = target.attr('data-vimeo-id') || target.attr('data-youtube-id'),
      width = target.attr('data-width') || this._core.settings.videoWidth,
      height = target.attr('data-height') || this._core.settings.videoHeight,
      url = target.attr('href');

    if (url) {
      id = url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

      if (id[3].indexOf('youtu') > -1) {
        type = 'youtube';
      } else if (id[3].indexOf('vimeo') > -1) {
        type = 'vimeo';
      } else {
        throw new Error('Video URL not supported.');
      }
      id = id[6];
    } else {
      throw new Error('Missing video URL.');
    }

    this._videos[url] = {
      type: type,
      id: id,
      width: width,
      height: height
    };

    item.attr('data-video', url);

    this.thumbnail(target, this._videos[url]);
  };

  /**
   * Creates video thumbnail.
   * @protected
   * @param {jQuery} target - The target containing the video data.
   * @param {Object} info - The video info object.
   * @see `fetch`
   */
  Video.prototype.thumbnail = function(target, video) {

    var tnLink,
      icon,
      path,
      dimensions = video.width && video.height ? 'style="width:' + video.width + 'px;height:' + video.height + 'px;"' : '',
      customTn = target.find('img'),
      srcType = 'src',
      lazyClass = '',
      settings = this._core.settings,
      create = function(path) {
        icon = '<div class="owl-video-play-icon"></div>';

        if (settings.lazyLoad) {
          tnLink = '<div class="owl-video-tn ' + lazyClass + '" ' + srcType + '="' + path + '"></div>';
        } else {
          tnLink = '<div class="owl-video-tn" style="opacity:1;background-image:url(' + path + ')"></div>';
        }
        target.after(tnLink);
        target.after(icon);
      };

    // wrap video content into owl-video-wrapper div
    target.wrap('<div class="owl-video-wrapper"' + dimensions + '></div>');

    if (this._core.settings.lazyLoad) {
      srcType = 'data-src';
      lazyClass = 'owl-lazy';
    }

    // custom thumbnail
    if (customTn.length) {
      create(customTn.attr(srcType));
      customTn.remove();
      return false;
    }

    if (video.type === 'youtube') {
      path = "http://img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
      create(path);
    } else if (video.type === 'vimeo') {
      $.ajax({
        type: 'GET',
        url: 'http://vimeo.com/api/v2/video/' + video.id + '.json',
        jsonp: 'callback',
        dataType: 'jsonp',
        success: function(data) {
          path = data[0].thumbnail_large;
          create(path);
        }
      });
    }
  };

  /**
   * Stops the current video.
   * @public
   */
  Video.prototype.stop = function() {
    this._core.trigger('stop', null, 'video');
    this._playing.find('.owl-video-frame').remove();
    this._playing.removeClass('owl-video-playing');
    this._playing = null;
  };

  /**
   * Starts the current video.
   * @public
   * @param {Event} ev - The event arguments.
   */
  Video.prototype.play = function(ev) {
    this._core.trigger('play', null, 'video');

    if (this._playing) {
      this.stop();
    }

    var target = $(ev.target || ev.srcElement),
      item = target.closest('.' + this._core.settings.itemClass),
      video = this._videos[item.attr('data-video')],
      width = video.width || '100%',
      height = video.height || this._core.$stage.height(),
      html, wrap;

    if (video.type === 'youtube') {
      html = '<iframe width="' + width + '" height="' + height + '" src="http://www.youtube.com/embed/' +
        video.id + '?autoplay=1&v=' + video.id + '" frameborder="0" allowfullscreen></iframe>';
    } else if (video.type === 'vimeo') {
      html = '<iframe src="http://player.vimeo.com/video/' + video.id + '?autoplay=1" width="' + width +
        '" height="' + height +
        '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
    }

    item.addClass('owl-video-playing');
    this._playing = item;

    wrap = $('<div style="height:' + height + 'px; width:' + width + 'px" class="owl-video-frame">' +
      html + '</div>');
    target.after(wrap);
  };

  /**
   * Checks whether an video is currently in full screen mode or not.
   * @todo Bad style because looks like a readonly method but changes members.
   * @protected
   * @returns {Boolean}
   */
  Video.prototype.isInFullScreen = function() {

    // if Vimeo Fullscreen mode
    var element = document.fullscreenElement || document.mozFullScreenElement ||
      document.webkitFullscreenElement;

    if (element && $(element).parent().hasClass('owl-video-frame')) {
      this._core.speed(0);
      this._fullscreen = true;
    }

    if (element && this._fullscreen && this._playing) {
      return false;
    }

    // comming back from fullscreen
    if (this._fullscreen) {
      this._fullscreen = false;
      return false;
    }

    // check full screen mode and window orientation
    if (this._playing) {
      if (this._core.state.orientation !== window.orientation) {
        this._core.state.orientation = window.orientation;
        return false;
      }
    }

    return true;
  };

  /**
   * Destroys the plugin.
   */
  Video.prototype.destroy = function() {
    var handler, property;

    this._core.$element.off('click.owl.video');

    for (handler in this._handlers) {
      this._core.$element.off(handler, this._handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.Video = Video;

})(window.Zepto || window.jQuery, window, document);

/**
 * Animate Plugin
 * @version 2.0.0
 * @author Bartosz Wojciechowski
 * @license The MIT License (MIT)
 */
;
(function($, window, document, undefined) {

  /**
   * Creates the animate plugin.
   * @class The Navigation Plugin
   * @param {Owl} scope - The Owl Carousel
   */
  var Animate = function(scope) {
    this.core = scope;
    this.core.options = $.extend({}, Animate.Defaults, this.core.options);
    this.swapping = true;
    this.previous = undefined;
    this.next = undefined;

    this.handlers = {
      'change.owl.carousel': $.proxy(function(e) {
        if (e.property.name == 'position') {
          this.previous = this.core.current();
          this.next = e.property.value;
        }
      }, this),
      'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
        this.swapping = e.type == 'translated';
      }, this),
      'translate.owl.carousel': $.proxy(function(e) {
        if (this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
          this.swap();
        }
      }, this)
    };

    this.core.$element.on(this.handlers);
  };

  /**
   * Default options.
   * @public
   */
  Animate.Defaults = {
    animateOut: false,
    animateIn: false
  };

  /**
   * Toggles the animation classes whenever an translations starts.
   * @protected
   * @returns {Boolean|undefined}
   */
  Animate.prototype.swap = function() {

    if (this.core.settings.items !== 1 || !this.core.support3d) {
      return;
    }

    this.core.speed(0);

    var left,
      clear = $.proxy(this.clear, this),
      previous = this.core.$stage.children().eq(this.previous),
      next = this.core.$stage.children().eq(this.next),
      incoming = this.core.settings.animateIn,
      outgoing = this.core.settings.animateOut;

    if (this.core.current() === this.previous) {
      return;
    }

    if (outgoing) {
      left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
      previous.css({
          'left': left + 'px'
        })
        .addClass('animated owl-animated-out')
        .addClass(outgoing)
        .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', clear);
    }

    if (incoming) {
      next.addClass('animated owl-animated-in')
        .addClass(incoming)
        .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', clear);
    }
  };

  Animate.prototype.clear = function(e) {
    $(e.target).css({
        'left': ''
      })
      .removeClass('animated owl-animated-out owl-animated-in')
      .removeClass(this.core.settings.animateIn)
      .removeClass(this.core.settings.animateOut);
    this.core.transitionEnd();
  }

  /**
   * Destroys the plugin.
   * @public
   */
  Animate.prototype.destroy = function() {
    var handler, property;

    for (handler in this.handlers) {
      this.core.$element.off(handler, this.handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.Animate = Animate;

})(window.Zepto || window.jQuery, window, document);

/**
 * Autoplay Plugin
 * @version 2.0.0
 * @author Bartosz Wojciechowski
 * @license The MIT License (MIT)
 */
;
(function($, window, document, undefined) {

  /**
   * Creates the autoplay plugin.
   * @class The Autoplay Plugin
   * @param {Owl} scope - The Owl Carousel
   */
  var Autoplay = function(scope) {
    this.core = scope;
    this.core.options = $.extend({}, Autoplay.Defaults, this.core.options);

    this.handlers = {
      'translated.owl.carousel refreshed.owl.carousel': $.proxy(function() {
        this.autoplay();
      }, this),
      'play.owl.autoplay': $.proxy(function(e, t, s) {
        this.play(t, s);
      }, this),
      'stop.owl.autoplay': $.proxy(function() {
        this.stop();
      }, this),
      'mouseover.owl.autoplay': $.proxy(function() {
        if (this.core.settings.autoplayHoverPause) {
          this.pause();
        }
      }, this),
      'mouseleave.owl.autoplay': $.proxy(function() {
        if (this.core.settings.autoplayHoverPause) {
          this.autoplay();
        }
      }, this)
    };

    this.core.$element.on(this.handlers);
  };

  /**
   * Default options.
   * @public
   */
  Autoplay.Defaults = {
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    autoplaySpeed: false
  };

  /**
   * @protected
   * @todo Must be documented.
   */
  Autoplay.prototype.autoplay = function() {
    if (this.core.settings.autoplay && !this.core.state.videoPlay) {
      window.clearInterval(this.interval);

      this.interval = window.setInterval($.proxy(function() {
        this.play();
      }, this), this.core.settings.autoplayTimeout);
    } else {
      window.clearInterval(this.interval);
    }
  };

  /**
   * Starts the autoplay.
   * @public
   * @param {Number} [timeout] - ...
   * @param {Number} [speed] - ...
   * @returns {Boolean|undefined} - ...
   * @todo Must be documented.
   */
  Autoplay.prototype.play = function(timeout, speed) {
    // if tab is inactive - doesnt work in <IE10
    if (document.hidden === true) {
      return;
    }

    if (this.core.state.isTouch || this.core.state.isScrolling ||
      this.core.state.isSwiping || this.core.state.inMotion) {
      return;
    }

    if (this.core.settings.autoplay === false) {
      window.clearInterval(this.interval);
      return;
    }

    this.core.next(this.core.settings.autoplaySpeed);
  };

  /**
   * Stops the autoplay.
   * @public
   */
  Autoplay.prototype.stop = function() {
    window.clearInterval(this.interval);
  };

  /**
   * Pauses the autoplay.
   * @public
   */
  Autoplay.prototype.pause = function() {
    window.clearInterval(this.interval);
  };

  /**
   * Destroys the plugin.
   */
  Autoplay.prototype.destroy = function() {
    var handler, property;

    window.clearInterval(this.interval);

    for (handler in this.handlers) {
      this.core.$element.off(handler, this.handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  };

  $.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;

})(window.Zepto || window.jQuery, window, document);

/**
 * Navigation Plugin
 * @version 2.0.0
 * @author Artus Kolanowski
 * @license The MIT License (MIT)
 */
;
(function($, window, document, undefined) {
  'use strict';

  /**
   * Creates the navigation plugin.
   * @class The Navigation Plugin
   * @param {Owl} carousel - The Owl Carousel.
   */
  var Navigation = function(carousel) {
    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * Indicates whether the plugin is initialized or not.
     * @protected
     * @type {Boolean}
     */
    this._initialized = false;

    /**
     * The current paging indexes.
     * @protected
     * @type {Array}
     */
    this._pages = [];

    /**
     * All DOM elements of the user interface.
     * @protected
     * @type {Object}
     */
    this._controls = {};

    /**
     * Markup for an indicator.
     * @protected
     * @type {Array.<String>}
     */
    this._templates = [];

    /**
     * The carousel element.
     * @type {jQuery}
     */
    this.$element = this._core.$element;

    /**
     * Overridden methods of the carousel.
     * @protected
     * @type {Object}
     */
    this._overrides = {
      next: this._core.next,
      prev: this._core.prev,
      to: this._core.to
    };

    /**
     * All event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'prepared.owl.carousel': $.proxy(function(e) {
        if (this._core.settings.dotsData) {
          this._templates.push($(e.content).find('[data-dot]').andSelf('[data-dot]').attr('data-dot'));
        }
      }, this),
      'add.owl.carousel': $.proxy(function(e) {
        if (this._core.settings.dotsData) {
          this._templates.splice(e.position, 0, $(e.content).find('[data-dot]').andSelf('[data-dot]').attr('data-dot'));
        }
      }, this),
      'remove.owl.carousel prepared.owl.carousel': $.proxy(function(e) {
        if (this._core.settings.dotsData) {
          this._templates.splice(e.position, 1);
        }
      }, this),
      'change.owl.carousel': $.proxy(function(e) {
        if (e.property.name == 'position') {
          if (!this._core.state.revert && !this._core.settings.loop && this._core.settings.navRewind) {
            var current = this._core.current(),
              maximum = this._core.maximum(),
              minimum = this._core.minimum();
            e.data = e.property.value > maximum ?
              current >= maximum ? minimum : maximum :
              e.property.value < minimum ? maximum : e.property.value;
          }
        }
      }, this),
      'changed.owl.carousel': $.proxy(function(e) {
        if (e.property.name == 'position') {
          this.draw();
        }
      }, this),
      'refreshed.owl.carousel': $.proxy(function() {
        if (!this._initialized) {
          this.initialize();
          this._initialized = true;
        }
        this._core.trigger('refresh', null, 'navigation');
        this.update();
        this.draw();
        this._core.trigger('refreshed', null, 'navigation');
      }, this)
    };

    // set default options
    this._core.options = $.extend({}, Navigation.Defaults, this._core.options);

    // register event handlers
    this.$element.on(this._handlers);
  }

  /**
   * Default options.
   * @public
   * @todo Rename `slideBy` to `navBy`
   */
  Navigation.Defaults = {
    nav: false,
    navRewind: true,
    navText: ['prev', 'next'],
    navSpeed: false,
    navElement: 'div',
    navContainer: false,
    navContainerClass: 'owl-nav',
    navClass: ['owl-prev', 'owl-next'],
    slideBy: 1,
    dotClass: 'owl-dot',
    dotsClass: 'owl-dots',
    dots: true,
    dotsEach: false,
    dotData: false,
    dotsSpeed: false,
    dotsContainer: false,
    controlsClass: 'owl-controls'
  }

  /**
   * Initializes the layout of the plugin and extends the carousel.
   * @protected
   */
  Navigation.prototype.initialize = function() {
    var $container, override,
      options = this._core.settings;

    // create the indicator template
    if (!options.dotsData) {
      this._templates = [$('<div>')
        .addClass(options.dotClass)
        .append($('<span>'))
        .prop('outerHTML')
      ];
    }

    // create controls container if needed
    if (!options.navContainer || !options.dotsContainer) {
      this._controls.$container = $('<div>')
        .addClass(options.controlsClass)
        .appendTo(this.$element);
    }

    // create DOM structure for absolute navigation
    this._controls.$indicators = options.dotsContainer ? $(options.dotsContainer) :
      $('<div>').hide().addClass(options.dotsClass).appendTo(this._controls.$container);

    this._controls.$indicators.on('click', 'div', $.proxy(function(e) {
      var index = $(e.target).parent().is(this._controls.$indicators) ?
        $(e.target).index() : $(e.target).parent().index();

      e.preventDefault();

      this.to(index, options.dotsSpeed);
    }, this));

    // create DOM structure for relative navigation
    $container = options.navContainer ? $(options.navContainer) :
      $('<div>').addClass(options.navContainerClass).prependTo(this._controls.$container);

    this._controls.$next = $('<' + options.navElement + '>');
    this._controls.$previous = this._controls.$next.clone();

    this._controls.$previous
      .addClass(options.navClass[0])
      .html(options.navText[0])
      .hide()
      .prependTo($container)
      .on('click', $.proxy(function(e) {
        this.prev(options.navSpeed);
      }, this));
    this._controls.$next
      .addClass(options.navClass[1])
      .html(options.navText[1])
      .hide()
      .appendTo($container)
      .on('click', $.proxy(function(e) {
        this.next(options.navSpeed);
      }, this));

    // override public methods of the carousel
    for (override in this._overrides) {
      this._core[override] = $.proxy(this[override], this);
    }
  }

  /**
   * Destroys the plugin.
   * @protected
   */
  Navigation.prototype.destroy = function() {
    var handler, control, property, override;

    for (handler in this._handlers) {
      this.$element.off(handler, this._handlers[handler]);
    }
    for (control in this._controls) {
      this._controls[control].remove();
    }
    for (override in this.overides) {
      this._core[override] = this._overrides[override];
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  }

  /**
   * Updates the internal state.
   * @protected
   */
  Navigation.prototype.update = function() {
    var i, j, k,
      options = this._core.settings,
      lower = this._core.clones().length / 2,
      upper = lower + this._core.items().length,
      size = options.center || options.autoWidth || options.dotData ?
      1 : options.dotsEach || options.items;

    if (options.slideBy !== 'page') {
      options.slideBy = Math.min(options.slideBy, options.items);
    }

    if (options.dots || options.slideBy == 'page') {
      this._pages = [];

      for (i = lower, j = 0, k = 0; i < upper; i++) {
        if (j >= size || j === 0) {
          this._pages.push({
            start: i - lower,
            end: i - lower + size - 1
          });
          j = 0, ++k;
        }
        j += this._core.mergers(this._core.relative(i));
      }
    }
  }

  /**
   * Draws the user interface.
   * @todo The option `dotData` wont work.
   * @protected
   */
  Navigation.prototype.draw = function() {
    var difference, i, html = '',
      options = this._core.settings,
      $items = this._core.$stage.children(),
      index = this._core.relative(this._core.current());

    if (options.nav && !options.loop && !options.navRewind) {
      this._controls.$previous.toggleClass('disabled', index <= 0);
      this._controls.$next.toggleClass('disabled', index >= this._core.maximum());
    }

    this._controls.$previous.toggle(options.nav);
    this._controls.$next.toggle(options.nav);

    if (options.dots) {
      difference = this._pages.length - this._controls.$indicators.children().length;

      if (options.dotData && difference !== 0) {
        for (i = 0; i < this._controls.$indicators.children().length; i++) {
          html += this._templates[this._core.relative(i)];
        }
        this._controls.$indicators.html(html);
      } else if (difference > 0) {
        html = new Array(difference + 1).join(this._templates[0]);
        this._controls.$indicators.append(html);
      } else if (difference < 0) {
        this._controls.$indicators.children().slice(difference).remove();
      }

      this._controls.$indicators.find('.active').removeClass('active');
      this._controls.$indicators.children().eq($.inArray(this.current(), this._pages)).addClass('active');
    }

    this._controls.$indicators.toggle(options.dots);
  }

  /**
   * Extends event data.
   * @protected
   * @param {Event} event - The event object which gets thrown.
   */
  Navigation.prototype.onTrigger = function(event) {
    var settings = this._core.settings;

    event.page = {
      index: $.inArray(this.current(), this._pages),
      count: this._pages.length,
      size: settings && (settings.center || settings.autoWidth || settings.dotData ?
        1 : settings.dotsEach || settings.items)
    };
  }

  /**
   * Gets the current page position of the carousel.
   * @protected
   * @returns {Number}
   */
  Navigation.prototype.current = function() {
    var index = this._core.relative(this._core.current());
    return $.grep(this._pages, function(o) {
      return o.start <= index && o.end >= index;
    }).pop();
  }

  /**
   * Gets the current succesor/predecessor position.
   * @protected
   * @returns {Number}
   */
  Navigation.prototype.getPosition = function(successor) {
    var position, length,
      options = this._core.settings;

    if (options.slideBy == 'page') {
      position = $.inArray(this.current(), this._pages);
      length = this._pages.length;
      successor ? ++position : --position;
      position = this._pages[((position % length) + length) % length].start;
    } else {
      position = this._core.relative(this._core.current());
      length = this._core.items().length;
      successor ? position += options.slideBy : position -= options.slideBy;
    }
    return position;
  }

  /**
   * Slides to the next item or page.
   * @public
   * @param {Number} [speed=false] - The time in milliseconds for the transition.
   */
  Navigation.prototype.next = function(speed) {
    $.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
  }

  /**
   * Slides to the previous item or page.
   * @public
   * @param {Number} [speed=false] - The time in milliseconds for the transition.
   */
  Navigation.prototype.prev = function(speed) {
    $.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
  }

  /**
   * Slides to the specified item or page.
   * @public
   * @param {Number} position - The position of the item or page.
   * @param {Number} [speed] - The time in milliseconds for the transition.
   * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
   */
  Navigation.prototype.to = function(position, speed, standard) {
    var length;

    if (!standard) {
      length = this._pages.length;
      $.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
    } else {
      $.proxy(this._overrides.to, this._core)(position, speed);
    }
  }

  $.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;

})(window.Zepto || window.jQuery, window, document);

/**
 * Hash Plugin
 * @version 2.0.0
 * @author Artus Kolanowski
 * @license The MIT License (MIT)
 */
;
(function($, window, document, undefined) {
  'use strict';

  /**
   * Creates the hash plugin.
   * @class The Hash Plugin
   * @param {Owl} carousel - The Owl Carousel
   */
  var Hash = function(carousel) {
    /**
     * Reference to the core.
     * @protected
     * @type {Owl}
     */
    this._core = carousel;

    /**
     * Hash table for the hashes.
     * @protected
     * @type {Object}
     */
    this._hashes = {};

    /**
     * The carousel element.
     * @type {jQuery}
     */
    this.$element = this._core.$element;

    /**
     * All event handlers.
     * @protected
     * @type {Object}
     */
    this._handlers = {
      'initialized.owl.carousel': $.proxy(function() {
        if (this._core.settings.startPosition == 'URLHash') {
          $(window).trigger('hashchange.owl.navigation');
        }
      }, this),
      'prepared.owl.carousel': $.proxy(function(e) {
        var hash = $(e.content).find('[data-hash]').andSelf('[data-hash]').attr('data-hash');
        this._hashes[hash] = e.content;
      }, this)
    };

    // set default options
    this._core.options = $.extend({}, Hash.Defaults, this._core.options);

    // register the event handlers
    this.$element.on(this._handlers);

    // register event listener for hash navigation
    $(window).on('hashchange.owl.navigation', $.proxy(function() {
      var hash = window.location.hash.substring(1),
        items = this._core.$stage.children(),
        position = this._hashes[hash] && items.index(this._hashes[hash]) || 0;

      if (!hash) {
        return false;
      }

      this._core.to(position, false, true);
    }, this));
  }

  /**
   * Default options.
   * @public
   */
  Hash.Defaults = {
    URLhashListener: false
  }

  /**
   * Destroys the plugin.
   * @public
   */
  Hash.prototype.destroy = function() {
    var handler, property;

    $(window).off('hashchange.owl.navigation');

    for (handler in this._handlers) {
      this._core.$element.off(handler, this._handlers[handler]);
    }
    for (property in Object.getOwnPropertyNames(this)) {
      typeof this[property] != 'function' && (this[property] = null);
    }
  }

  $.fn.owlCarousel.Constructor.Plugins.Hash = Hash;

})(window.Zepto || window.jQuery, window, document);



/*
var _gaq = _gaq || [];
  _gaq.push(['_setAccount', 'UA-46767630-1']);
  _gaq.push(['_setDomainName', window.object_name+'.com']);
  _gaq.push(['_setAllowLinker', true]);
  _gaq.push(['_trackPageview']);

  (function() {
    var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
    ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
  })()

*/

/**!
 * MixItUp v2.1.11
 *
 * @copyright Copyright 2015 KunkaLabs Limited.
 * @author    KunkaLabs Limited.
 * @link      https://mixitup.kunkalabs.com
 *
 * @license   Commercial use requires a commercial license.
 *            https://mixitup.kunkalabs.com/licenses/
 *
 *            Non-commercial use permitted under terms of CC-BY-NC license.
 *            http://creativecommons.org/licenses/by-nc/3.0/
 */

(function($, undf) {
  'use strict';

  /**
   * MixItUp Constructor Function
   * @constructor
   * @extends jQuery
   */

  $.MixItUp = function() {
    var self = this;

    self._execAction('_constructor', 0);

    $.extend(self, {

      /* Public Properties
      ---------------------------------------------------------------------- */

      selectors: {
        target: '.mix',
        filter: '.filter',
        sort: '.sort'
      },

      animation: {
        enable: true,
        effects: 'fade scale',
        duration: 600,
        easing: 'ease',
        perspectiveDistance: '3000',
        perspectiveOrigin: '50% 50%',
        queue: true,
        queueLimit: 1,
        animateChangeLayout: false,
        animateResizeContainer: true,
        animateResizeTargets: false,
        staggerSequence: false,
        reverseOut: false
      },

      callbacks: {
        onMixLoad: false,
        onMixStart: false,
        onMixBusy: false,
        onMixEnd: false,
        onMixFail: false,
        _user: false
      },

      controls: {
        enable: true,
        live: false,
        toggleFilterButtons: false,
        toggleLogic: 'or',
        activeClass: 'active'
      },

      layout: {
        display: 'inline-block',
        containerClass: '',
        containerClassFail: 'fail'
      },

      load: {
        filter: 'all',
        sort: false
      },

      /* Private Properties
      ---------------------------------------------------------------------- */

      _$body: null,
      _$container: null,
      _$targets: null,
      _$parent: null,
      _$sortButtons: null,
      _$filterButtons: null,

      _suckMode: false,
      _mixing: false,
      _sorting: false,
      _clicking: false,
      _loading: true,
      _changingLayout: false,
      _changingClass: false,
      _changingDisplay: false,

      _origOrder: [],
      _startOrder: [],
      _newOrder: [],
      _activeFilter: null,
      _toggleArray: [],
      _toggleString: '',
      _activeSort: 'default:asc',
      _newSort: null,
      _startHeight: null,
      _newHeight: null,
      _incPadding: true,
      _newDisplay: null,
      _newClass: null,
      _targetsBound: 0,
      _targetsDone: 0,
      _queue: [],

      _$show: $(),
      _$hide: $()
    });

    self._execAction('_constructor', 1);
  };

  /**
   * MixItUp Prototype
   * @override
   */

  $.MixItUp.prototype = {
    constructor: $.MixItUp,

    /* Static Properties
    ---------------------------------------------------------------------- */

    _instances: {},
    _handled: {
      _filter: {},
      _sort: {}
    },
    _bound: {
      _filter: {},
      _sort: {}
    },
    _actions: {},
    _filters: {},

    /* Static Methods
    ---------------------------------------------------------------------- */

    /**
     * Extend
     * @since 2.1.0
     * @param {object} new properties/methods
     * @extends {object} prototype
     */

    extend: function(extension) {
      for (var key in extension) {
        $.MixItUp.prototype[key] = extension[key];
      }
    },

    /**
     * Add Action
     * @since 2.1.0
     * @param {string} hook name
     * @param {string} namespace
     * @param {function} function to execute
     * @param {number} priority
     * @extends {object} $.MixItUp.prototype._actions
     */

    addAction: function(hook, name, func, priority) {
      $.MixItUp.prototype._addHook('_actions', hook, name, func, priority);
    },

    /**
     * Add Filter
     * @since 2.1.0
     * @param {string} hook name
     * @param {string} namespace
     * @param {function} function to execute
     * @param {number} priority
     * @extends {object} $.MixItUp.prototype._filters
     */

    addFilter: function(hook, name, func, priority) {
      $.MixItUp.prototype._addHook('_filters', hook, name, func, priority);
    },

    /**
     * Add Hook
     * @since 2.1.0
     * @param {string} type of hook
     * @param {string} hook name
     * @param {function} function to execute
     * @param {number} priority
     * @extends {object} $.MixItUp.prototype._filters
     */

    _addHook: function(type, hook, name, func, priority) {
      var collection = $.MixItUp.prototype[type],
        obj = {};

      priority = (priority === 1 || priority === 'post') ? 'post' : 'pre';

      obj[hook] = {};
      obj[hook][priority] = {};
      obj[hook][priority][name] = func;

      $.extend(true, collection, obj);
    },


    /* Private Methods
    ---------------------------------------------------------------------- */

    /**
     * Initialise
     * @since 2.0.0
     * @param {object} domNode
     * @param {object} config
     */

    _init: function(domNode, config) {
      var self = this;

      self._execAction('_init', 0, arguments);

      config && $.extend(true, self, config);

      self._$body = $('body');
      self._domNode = domNode;
      self._$container = $(domNode);
      self._$container.addClass(self.layout.containerClass);
      self._id = domNode.id;

      self._platformDetect();

      self._brake = self._getPrefixedCSS('transition', 'none');

      self._refresh(true);

      self._$parent = self._$targets.parent().length ? self._$targets.parent() : self._$container;

      if (self.load.sort) {
        self._newSort = self._parseSort(self.load.sort);
        self._newSortString = self.load.sort;
        self._activeSort = self.load.sort;
        self._sort();
        self._printSort();
      }

      self._activeFilter = self.load.filter === 'all' ?
        self.selectors.target :
        self.load.filter === 'none' ?
        '' :
        self.load.filter;

      self.controls.enable && self._bindHandlers();

      if (self.controls.toggleFilterButtons) {
        self._buildToggleArray();

        for (var i = 0; i < self._toggleArray.length; i++) {
          self._updateControls({
            filter: self._toggleArray[i],
            sort: self._activeSort
          }, true);
        };
      } else if (self.controls.enable) {
        self._updateControls({
          filter: self._activeFilter,
          sort: self._activeSort
        });
      }

      self._filter();

      self._init = true;

      self._$container.data('mixItUp', self);

      self._execAction('_init', 1, arguments);

      self._buildState();

      self._$targets.css(self._brake);

      self._goMix(self.animation.enable);
    },

    /**
     * Platform Detect
     * @since 2.0.0
     */

    _platformDetect: function() {
      var self = this,
        vendorsTrans = ['Webkit', 'Moz', 'O', 'ms'],
        vendorsRAF = ['webkit', 'moz'],
        chrome = window.navigator.appVersion.match(/Chrome\/(\d+)\./) || false,
        ff = typeof InstallTrigger !== 'undefined',
        prefix = function(el) {
          for (var i = 0; i < vendorsTrans.length; i++) {
            if (vendorsTrans[i] + 'Transition' in el.style) {
              return {
                prefix: '-' + vendorsTrans[i].toLowerCase() + '-',
                vendor: vendorsTrans[i]
              };
            };
          };
          return 'transition' in el.style ? '' : false;
        },
        transPrefix = prefix(self._domNode);

      self._execAction('_platformDetect', 0);

      self._chrome = chrome ? parseInt(chrome[1], 10) : false;
      self._ff = ff ? parseInt(window.navigator.userAgent.match(/rv:([^)]+)\)/)[1]) : false;
      self._prefix = transPrefix.prefix;
      self._vendor = transPrefix.vendor;
      self._suckMode = window.atob && self._prefix ? false : true;

      self._suckMode && (self.animation.enable = false);
      (self._ff && self._ff <= 4) && (self.animation.enable = false);

      /* Polyfills
      ---------------------------------------------------------------------- */

      /**
       * window.requestAnimationFrame
       */

      for (var x = 0; x < vendorsRAF.length && !window.requestAnimationFrame; x++) {
        window.requestAnimationFrame = window[vendorsRAF[x] + 'RequestAnimationFrame'];
      }

      /**
       * Object.getPrototypeOf
       */

      if (typeof Object.getPrototypeOf !== 'function') {
        if (typeof 'test'.__proto__ === 'object') {
          Object.getPrototypeOf = function(object) {
            return object.__proto__;
          };
        } else {
          Object.getPrototypeOf = function(object) {
            return object.constructor.prototype;
          };
        }
      }

      /**
       * Element.nextElementSibling
       */

      if (self._domNode.nextElementSibling === undf) {
        Object.defineProperty(Element.prototype, 'nextElementSibling', {
          get: function() {
            var el = this.nextSibling;

            while (el) {
              if (el.nodeType === 1) {
                return el;
              }
              el = el.nextSibling;
            }
            return null;
          }
        });
      }

      self._execAction('_platformDetect', 1);
    },

    /**
     * Refresh
     * @since 2.0.0
     * @param {boolean} init
     * @param {boolean} force
     */

    _refresh: function(init, force) {
      var self = this;

      self._execAction('_refresh', 0, arguments);

      self._$targets = self._$container.find(self.selectors.target);

      for (var i = 0; i < self._$targets.length; i++) {
        var target = self._$targets[i];

        if (target.dataset === undf || force) {

          target.dataset = {};

          for (var j = 0; j < target.attributes.length; j++) {

            var attr = target.attributes[j],
              name = attr.name,
              val = attr.value;

            if (name.indexOf('data-') > -1) {
              var dataName = self._helpers._camelCase(name.substring(5, name.length));
              target.dataset[dataName] = val;
            }
          }
        }

        if (target.mixParent === undf) {
          target.mixParent = self._id;
        }
      }

      if (
        (self._$targets.length && init) ||
        (!self._origOrder.length && self._$targets.length)
      ) {
        self._origOrder = [];

        for (var i = 0; i < self._$targets.length; i++) {
          var target = self._$targets[i];

          self._origOrder.push(target);
        }
      }

      self._execAction('_refresh', 1, arguments);
    },

    /**
     * Bind Handlers
     * @since 2.0.0
     */

    _bindHandlers: function() {
      var self = this,
        filters = $.MixItUp.prototype._bound._filter,
        sorts = $.MixItUp.prototype._bound._sort;

      self._execAction('_bindHandlers', 0);

      if (self.controls.live) {
        self._$body
          .on('click.mixItUp.' + self._id, self.selectors.sort, function() {
            self._processClick($(this), 'sort');
          })
          .on('click.mixItUp.' + self._id, self.selectors.filter, function() {
            self._processClick($(this), 'filter');
          });
      } else {
        self._$sortButtons = $(self.selectors.sort);
        self._$filterButtons = $(self.selectors.filter);

        self._$sortButtons.on('click.mixItUp.' + self._id, function() {
          self._processClick($(this), 'sort');
        });

        self._$filterButtons.on('click.mixItUp.' + self._id, function() {
          self._processClick($(this), 'filter');
        });
      }

      filters[self.selectors.filter] = (filters[self.selectors.filter] === undf) ? 1 : filters[self.selectors.filter] + 1;
      sorts[self.selectors.sort] = (sorts[self.selectors.sort] === undf) ? 1 : sorts[self.selectors.sort] + 1;

      self._execAction('_bindHandlers', 1);
    },

    /**
     * Process Click
     * @since 2.0.0
     * @param {object} $button
     * @param {string} type
     */

    _processClick: function($button, type) {
      var self = this,
        trackClick = function($button, type, off) {
          var proto = $.MixItUp.prototype;

          proto._handled['_' + type][self.selectors[type]] = (proto._handled['_' + type][self.selectors[type]] === undf) ?
            1 :
            proto._handled['_' + type][self.selectors[type]] + 1;

          if (proto._handled['_' + type][self.selectors[type]] === proto._bound['_' + type][self.selectors[type]]) {
            $button[(off ? 'remove' : 'add') + 'Class'](self.controls.activeClass);
            delete proto._handled['_' + type][self.selectors[type]];
          }
        };

      self._execAction('_processClick', 0, arguments);

      if (!self._mixing || (self.animation.queue && self._queue.length < self.animation.queueLimit)) {
        self._clicking = true;

        if (type === 'sort') {
          var sort = $button.attr('data-sort');

          if (!$button.hasClass(self.controls.activeClass) || sort.indexOf('random') > -1) {
            $(self.selectors.sort).removeClass(self.controls.activeClass);
            trackClick($button, type);
            self.sort(sort);
          }
        }

        if (type === 'filter') {
          var filter = $button.attr('data-filter'),
            ndx,
            seperator = self.controls.toggleLogic === 'or' ? ',' : '';

          if (!self.controls.toggleFilterButtons) {
            if (!$button.hasClass(self.controls.activeClass)) {
              $(self.selectors.filter).removeClass(self.controls.activeClass);
              trackClick($button, type);
              self.filter(filter);
            }
          } else {
            self._buildToggleArray();

            if (!$button.hasClass(self.controls.activeClass)) {
              trackClick($button, type);

              self._toggleArray.push(filter);
            } else {
              trackClick($button, type, true);
              ndx = self._toggleArray.indexOf(filter);
              self._toggleArray.splice(ndx, 1);
            }

            self._toggleArray = $.grep(self._toggleArray, function(n) {
              return (n);
            });

            self._toggleString = self._toggleArray.join(seperator);

            self.filter(self._toggleString);
          }
        }

        self._execAction('_processClick', 1, arguments);
      } else {
        if (typeof self.callbacks.onMixBusy === 'function') {
          self.callbacks.onMixBusy.call(self._domNode, self._state, self);
        }
        self._execAction('_processClickBusy', 1, arguments);
      }
    },

    /**
     * Build Toggle Array
     * @since 2.0.0
     */

    _buildToggleArray: function() {
      var self = this,
        activeFilter = self._activeFilter.replace(/\s/g, '');

      self._execAction('_buildToggleArray', 0, arguments);

      if (self.controls.toggleLogic === 'or') {
        self._toggleArray = activeFilter.split(',');
      } else {
        self._toggleArray = activeFilter.split('.');

        !self._toggleArray[0] && self._toggleArray.shift();

        for (var i = 0, filter; filter = self._toggleArray[i]; i++) {
          self._toggleArray[i] = '.' + filter;
        }
      }

      self._execAction('_buildToggleArray', 1, arguments);
    },

    /**
     * Update Controls
     * @since 2.0.0
     * @param {object} command
     * @param {boolean} multi
     */

    _updateControls: function(command, multi) {
      var self = this,
        output = {
          filter: command.filter,
          sort: command.sort
        },
        update = function($el, filter) {
          try {
            (multi && type === 'filter' && !(output.filter === 'none' || output.filter === '')) ?
            $el.filter(filter).addClass(self.controls.activeClass):
              $el.removeClass(self.controls.activeClass).filter(filter).addClass(self.controls.activeClass);
          } catch (e) {}
        },
        type = 'filter',
        $el = null;

      self._execAction('_updateControls', 0, arguments);

      (command.filter === undf) && (output.filter = self._activeFilter);
      (command.sort === undf) && (output.sort = self._activeSort);
      (output.filter === self.selectors.target) && (output.filter = 'all');

      for (var i = 0; i < 2; i++) {
        $el = self.controls.live ? $(self.selectors[type]) : self['_$' + type + 'Buttons'];
        $el && update($el, '[data-' + type + '="' + output[type] + '"]');
        type = 'sort';
      }

      self._execAction('_updateControls', 1, arguments);
    },

    /**
     * Filter (private)
     * @since 2.0.0
     */

    _filter: function() {
      var self = this;

      self._execAction('_filter', 0);

      for (var i = 0; i < self._$targets.length; i++) {
        var $target = $(self._$targets[i]);

        if ($target.is(self._activeFilter)) {
          self._$show = self._$show.add($target);
        } else {
          self._$hide = self._$hide.add($target);
        }
      }

      self._execAction('_filter', 1);
    },

    /**
     * Sort (private)
     * @since 2.0.0
     */

    _sort: function() {
      var self = this,
        arrayShuffle = function(oldArray) {
          var newArray = oldArray.slice(),
            len = newArray.length,
            i = len;

          while (i--) {
            var p = parseInt(Math.random() * len);
            var t = newArray[i];
            newArray[i] = newArray[p];
            newArray[p] = t;
          };
          return newArray;
        };

      self._execAction('_sort', 0);

      self._startOrder = [];

      for (var i = 0; i < self._$targets.length; i++) {
        var target = self._$targets[i];

        self._startOrder.push(target);
      }

      switch (self._newSort[0].sortBy) {
        case 'default':
          self._newOrder = self._origOrder;
          break;
        case 'random':
          self._newOrder = arrayShuffle(self._startOrder);
          break;
        case 'custom':
          self._newOrder = self._newSort[0].order;
          break;
        default:
          self._newOrder = self._startOrder.concat().sort(function(a, b) {
            return self._compare(a, b);
          });
      }

      self._execAction('_sort', 1);
    },

    /**
     * Compare Algorithm
     * @since 2.0.0
     * @param {string|number} a
     * @param {string|number} b
     * @param {number} depth (recursion)
     * @return {number}
     */

    _compare: function(a, b, depth) {
      depth = depth ? depth : 0;

      var self = this,
        order = self._newSort[depth].order,
        getData = function(el) {
          return el.dataset[self._newSort[depth].sortBy] || 0;
        },
        attrA = isNaN(getData(a) * 1) ? getData(a).toLowerCase() : getData(a) * 1,
        attrB = isNaN(getData(b) * 1) ? getData(b).toLowerCase() : getData(b) * 1;

      if (attrA < attrB)
        return order === 'asc' ? -1 : 1;
      if (attrA > attrB)
        return order === 'asc' ? 1 : -1;
      if (attrA === attrB && self._newSort.length > depth + 1)
        return self._compare(a, b, depth + 1);

      return 0;
    },

    /**
     * Print Sort
     * @since 2.0.0
     * @param {boolean} reset
     */

    _printSort: function(reset) {
      var self = this,
        order = reset ? self._startOrder : self._newOrder,
        targets = self._$parent[0].querySelectorAll(self.selectors.target),
        nextSibling = targets.length ? targets[targets.length - 1].nextElementSibling : null,
        frag = document.createDocumentFragment();

      self._execAction('_printSort', 0, arguments);

      for (var i = 0; i < targets.length; i++) {
        var target = targets[i],
          whiteSpace = target.nextSibling;

        if (target.style.position === 'absolute') continue;

        if (whiteSpace && whiteSpace.nodeName === '#text') {
          self._$parent[0].removeChild(whiteSpace);
        }

        self._$parent[0].removeChild(target);
      }

      for (var i = 0; i < order.length; i++) {
        var el = order[i];

        if (self._newSort[0].sortBy === 'default' && self._newSort[0].order === 'desc' && !reset) {
          var firstChild = frag.firstChild;
          frag.insertBefore(el, firstChild);
          frag.insertBefore(document.createTextNode(' '), el);
        } else {
          frag.appendChild(el);
          frag.appendChild(document.createTextNode(' '));
        }
      }

      nextSibling ?
        self._$parent[0].insertBefore(frag, nextSibling) :
        self._$parent[0].appendChild(frag);

      self._execAction('_printSort', 1, arguments);
    },

    /**
     * Parse Sort
     * @since 2.0.0
     * @param {string} sortString
     * @return {array} newSort
     */

    _parseSort: function(sortString) {
      var self = this,
        rules = typeof sortString === 'string' ? sortString.split(' ') : [sortString],
        newSort = [];

      for (var i = 0; i < rules.length; i++) {
        var rule = typeof sortString === 'string' ? rules[i].split(':') : ['custom', rules[i]],
          ruleObj = {
            sortBy: self._helpers._camelCase(rule[0]),
            order: rule[1] || 'asc'
          };

        newSort.push(ruleObj);

        if (ruleObj.sortBy === 'default' || ruleObj.sortBy === 'random') break;
      }

      return self._execFilter('_parseSort', newSort, arguments);
    },

    /**
     * Parse Effects
     * @since 2.0.0
     * @return {object} effects
     */

    _parseEffects: function() {
      var self = this,
        effects = {
          opacity: '',
          transformIn: '',
          transformOut: '',
          filter: ''
        },
        parse = function(effect, extract, reverse) {
          if (self.animation.effects.indexOf(effect) > -1) {
            if (extract) {
              var propIndex = self.animation.effects.indexOf(effect + '(');
              if (propIndex > -1) {
                var str = self.animation.effects.substring(propIndex),
                  match = /\(([^)]+)\)/.exec(str),
                  val = match[1];

                return {
                  val: val
                };
              }
            }
            return true;
          } else {
            return false;
          }
        },
        negate = function(value, invert) {
          if (invert) {
            return value.charAt(0) === '-' ? value.substr(1, value.length) : '-' + value;
          } else {
            return value;
          }
        },
        buildTransform = function(key, invert) {
          var transforms = [
            ['scale', '.01'],
            ['translateX', '20px'],
            ['translateY', '20px'],
            ['translateZ', '20px'],
            ['rotateX', '90deg'],
            ['rotateY', '90deg'],
            ['rotateZ', '180deg'],
          ];

          for (var i = 0; i < transforms.length; i++) {
            var prop = transforms[i][0],
              def = transforms[i][1],
              inverted = invert && prop !== 'scale';

            effects[key] += parse(prop) ? prop + '(' + negate(parse(prop, true).val || def, inverted) + ') ' : '';
          }
        };

      effects.opacity = parse('fade') ? parse('fade', true).val || '0' : '1';

      buildTransform('transformIn');

      self.animation.reverseOut ? buildTransform('transformOut', true) : (effects.transformOut = effects.transformIn);

      effects.transition = {};

      effects.transition = self._getPrefixedCSS('transition', 'all ' + self.animation.duration + 'ms ' + self.animation.easing + ', opacity ' + self.animation.duration + 'ms linear');

      self.animation.stagger = parse('stagger') ? true : false;
      self.animation.staggerDuration = parseInt(parse('stagger') ? (parse('stagger', true).val ? parse('stagger', true).val : 100) : 100);

      return self._execFilter('_parseEffects', effects);
    },

    /**
     * Build State
     * @since 2.0.0
     * @param {boolean} future
     * @return {object} futureState
     */

    _buildState: function(future) {
      var self = this,
        state = {};

      self._execAction('_buildState', 0);

      state = {
        activeFilter: self._activeFilter === '' ? 'none' : self._activeFilter,
        activeSort: future && self._newSortString ? self._newSortString : self._activeSort,
        fail: !self._$show.length && self._activeFilter !== '',
        $targets: self._$targets,
        $show: self._$show,
        $hide: self._$hide,
        totalTargets: self._$targets.length,
        totalShow: self._$show.length,
        totalHide: self._$hide.length,
        display: future && self._newDisplay ? self._newDisplay : self.layout.display
      };

      if (future) {
        return self._execFilter('_buildState', state);
      } else {
        self._state = state;

        self._execAction('_buildState', 1);
      }
    },

    /**
     * Go Mix
     * @since 2.0.0
     * @param {boolean} animate
     */

    _goMix: function(animate) {
      var self = this,
        phase1 = function() {
          if (self._chrome && (self._chrome === 31)) {
            chromeFix(self._$parent[0]);
          }

          self._setInter();

          phase2();
        },
        phase2 = function() {
          var scrollTop = window.pageYOffset,
            scrollLeft = window.pageXOffset,
            docHeight = document.documentElement.scrollHeight;

          self._getInterMixData();

          self._setFinal();

          self._getFinalMixData();

          (window.pageYOffset !== scrollTop) && window.scrollTo(scrollLeft, scrollTop);

          self._prepTargets();

          if (window.requestAnimationFrame) {
            requestAnimationFrame(phase3);
          } else {
            setTimeout(function() {
              phase3();
            }, 20);
          }
        },
        phase3 = function() {
          self._animateTargets();

          if (self._targetsBound === 0) {
            self._cleanUp();
          }
        },
        chromeFix = function(grid) {
          var parent = grid.parentElement,
            placeholder = document.createElement('div'),
            frag = document.createDocumentFragment();

          parent.insertBefore(placeholder, grid);
          frag.appendChild(grid);
          parent.replaceChild(grid, placeholder);
        },
        futureState = self._buildState(true);

      self._execAction('_goMix', 0, arguments);

      !self.animation.duration && (animate = false);

      self._mixing = true;

      self._$container.removeClass(self.layout.containerClassFail);

      if (typeof self.callbacks.onMixStart === 'function') {
        self.callbacks.onMixStart.call(self._domNode, self._state, futureState, self);
      }

      self._$container.trigger('mixStart', [self._state, futureState, self]);

      self._getOrigMixData();

      if (animate && !self._suckMode) {

        window.requestAnimationFrame ?
          requestAnimationFrame(phase1) :
          phase1();

      } else {
        self._cleanUp();
      }

      self._execAction('_goMix', 1, arguments);
    },

    /**
     * Get Target Data
     * @since 2.0.0
     */

    _getTargetData: function(el, stage) {
      var self = this,
        elStyle;

      el.dataset[stage + 'PosX'] = el.offsetLeft;
      el.dataset[stage + 'PosY'] = el.offsetTop;

      if (self.animation.animateResizeTargets) {
        elStyle = !self._suckMode ?
          window.getComputedStyle(el) : {
            marginBottom: '',
            marginRight: ''
          };

        el.dataset[stage + 'MarginBottom'] = parseInt(elStyle.marginBottom);
        el.dataset[stage + 'MarginRight'] = parseInt(elStyle.marginRight);
        el.dataset[stage + 'Width'] = el.offsetWidth;
        el.dataset[stage + 'Height'] = el.offsetHeight;
      }
    },

    /**
     * Get Original Mix Data
     * @since 2.0.0
     */

    _getOrigMixData: function() {
      var self = this,
        parentStyle = !self._suckMode ? window.getComputedStyle(self._$parent[0]) : {
          boxSizing: ''
        },
        parentBS = parentStyle.boxSizing || parentStyle[self._vendor + 'BoxSizing'];

      self._incPadding = (parentBS === 'border-box');

      self._execAction('_getOrigMixData', 0);

      !self._suckMode && (self.effects = self._parseEffects());

      self._$toHide = self._$hide.filter(':visible');
      self._$toShow = self._$show.filter(':hidden');
      self._$pre = self._$targets.filter(':visible');

      self._startHeight = self._incPadding ?
        self._$parent.outerHeight() :
        self._$parent.height();

      for (var i = 0; i < self._$pre.length; i++) {
        var el = self._$pre[i];

        self._getTargetData(el, 'orig');
      }

      self._execAction('_getOrigMixData', 1);
    },

    /**
     * Set Intermediate Positions
     * @since 2.0.0
     */

    _setInter: function() {
      var self = this;

      self._execAction('_setInter', 0);

      if (self._changingLayout && self.animation.animateChangeLayout) {
        self._$toShow.css('display', self._newDisplay);

        if (self._changingClass) {
          self._$container
            .removeClass(self.layout.containerClass)
            .addClass(self._newClass);
        }
      } else {
        self._$toShow.css('display', self.layout.display);
      }

      self._execAction('_setInter', 1);
    },

    /**
     * Get Intermediate Mix Data
     * @since 2.0.0
     */

    _getInterMixData: function() {
      var self = this;

      self._execAction('_getInterMixData', 0);

      for (var i = 0; i < self._$toShow.length; i++) {
        var el = self._$toShow[i];

        self._getTargetData(el, 'inter');
      }

      for (var i = 0; i < self._$pre.length; i++) {
        var el = self._$pre[i];

        self._getTargetData(el, 'inter');
      }

      self._execAction('_getInterMixData', 1);
    },

    /**
     * Set Final Positions
     * @since 2.0.0
     */

    _setFinal: function() {
      var self = this;

      self._execAction('_setFinal', 0);

      self._sorting && self._printSort();

      self._$toHide.removeStyle('display');

      if (self._changingLayout && self.animation.animateChangeLayout) {
        self._$pre.css('display', self._newDisplay);
      }

      self._execAction('_setFinal', 1);
    },

    /**
     * Get Final Mix Data
     * @since 2.0.0
     */

    _getFinalMixData: function() {
      var self = this;

      self._execAction('_getFinalMixData', 0);

      for (var i = 0; i < self._$toShow.length; i++) {
        var el = self._$toShow[i];

        self._getTargetData(el, 'final');
      }

      for (var i = 0; i < self._$pre.length; i++) {
        var el = self._$pre[i];

        self._getTargetData(el, 'final');
      }

      self._newHeight = self._incPadding ?
        self._$parent.outerHeight() :
        self._$parent.height();

      self._sorting && self._printSort(true);

      self._$toShow.removeStyle('display');

      self._$pre.css('display', self.layout.display);

      if (self._changingClass && self.animation.animateChangeLayout) {
        self._$container
          .removeClass(self._newClass)
          .addClass(self.layout.containerClass);
      }

      self._execAction('_getFinalMixData', 1);
    },

    /**
     * Prepare Targets
     * @since 2.0.0
     */

    _prepTargets: function() {
      var self = this,
        transformCSS = {
          _in: self._getPrefixedCSS('transform', self.effects.transformIn),
          _out: self._getPrefixedCSS('transform', self.effects.transformOut)
        };

      self._execAction('_prepTargets', 0);

      if (self.animation.animateResizeContainer) {
        self._$parent.css('height', self._startHeight + 'px');
      }

      for (var i = 0; i < self._$toShow.length; i++) {
        var el = self._$toShow[i],
          $el = $(el);

        el.style.opacity = self.effects.opacity;
        el.style.display = (self._changingLayout && self.animation.animateChangeLayout) ?
          self._newDisplay :
          self.layout.display;

        $el.css(transformCSS._in);

        if (self.animation.animateResizeTargets) {
          el.style.width = el.dataset.finalWidth + 'px';
          el.style.height = el.dataset.finalHeight + 'px';
          el.style.marginRight = -(el.dataset.finalWidth - el.dataset.interWidth) + (el.dataset.finalMarginRight * 1) + 'px';
          el.style.marginBottom = -(el.dataset.finalHeight - el.dataset.interHeight) + (el.dataset.finalMarginBottom * 1) + 'px';
        }
      }

      for (var i = 0; i < self._$pre.length; i++) {
        var el = self._$pre[i],
          $el = $(el),
          translate = {
            x: el.dataset.origPosX - el.dataset.interPosX,
            y: el.dataset.origPosY - el.dataset.interPosY
          },
          transformCSS = self._getPrefixedCSS('transform', 'translate(' + translate.x + 'px,' + translate.y + 'px)');

        $el.css(transformCSS);

        if (self.animation.animateResizeTargets) {
          el.style.width = el.dataset.origWidth + 'px';
          el.style.height = el.dataset.origHeight + 'px';

          if (el.dataset.origWidth - el.dataset.finalWidth) {
            el.style.marginRight = -(el.dataset.origWidth - el.dataset.interWidth) + (el.dataset.origMarginRight * 1) + 'px';
          }

          if (el.dataset.origHeight - el.dataset.finalHeight) {
            el.style.marginBottom = -(el.dataset.origHeight - el.dataset.interHeight) + (el.dataset.origMarginBottom * 1) + 'px';
          }
        }
      }

      self._execAction('_prepTargets', 1);
    },

    /**
     * Animate Targets
     * @since 2.0.0
     */

    _animateTargets: function() {
      var self = this;

      self._execAction('_animateTargets', 0);

      self._targetsDone = 0;
      self._targetsBound = 0;

      self._$parent
        .css(self._getPrefixedCSS('perspective', self.animation.perspectiveDistance + 'px'))
        .css(self._getPrefixedCSS('perspective-origin', self.animation.perspectiveOrigin));

      if (self.animation.animateResizeContainer) {
        self._$parent
          .css(self._getPrefixedCSS('transition', 'height ' + self.animation.duration + 'ms ease'))
          .css('height', self._newHeight + 'px');
      }

      for (var i = 0; i < self._$toShow.length; i++) {
        var el = self._$toShow[i],
          $el = $(el),
          translate = {
            x: el.dataset.finalPosX - el.dataset.interPosX,
            y: el.dataset.finalPosY - el.dataset.interPosY
          },
          delay = self._getDelay(i),
          toShowCSS = {};

        el.style.opacity = '';

        for (var j = 0; j < 2; j++) {
          var a = j === 0 ? a = self._prefix : '';

          if (self._ff && self._ff <= 20) {
            toShowCSS[a + 'transition-property'] = 'all';
            toShowCSS[a + 'transition-timing-function'] = self.animation.easing + 'ms';
            toShowCSS[a + 'transition-duration'] = self.animation.duration + 'ms';
          }

          toShowCSS[a + 'transition-delay'] = delay + 'ms';
          toShowCSS[a + 'transform'] = 'translate(' + translate.x + 'px,' + translate.y + 'px)';
        }

        if (self.effects.transform || self.effects.opacity) {
          self._bindTargetDone($el);
        }

        (self._ff && self._ff <= 20) ?
        $el.css(toShowCSS):
          $el.css(self.effects.transition).css(toShowCSS);
      }

      for (var i = 0; i < self._$pre.length; i++) {
        var el = self._$pre[i],
          $el = $(el),
          translate = {
            x: el.dataset.finalPosX - el.dataset.interPosX,
            y: el.dataset.finalPosY - el.dataset.interPosY
          },
          delay = self._getDelay(i);

        if (!(
            el.dataset.finalPosX === el.dataset.origPosX &&
            el.dataset.finalPosY === el.dataset.origPosY
          )) {
          self._bindTargetDone($el);
        }

        $el.css(self._getPrefixedCSS('transition', 'all ' + self.animation.duration + 'ms ' + self.animation.easing + ' ' + delay + 'ms'));
        $el.css(self._getPrefixedCSS('transform', 'translate(' + translate.x + 'px,' + translate.y + 'px)'));

        if (self.animation.animateResizeTargets) {
          if (el.dataset.origWidth - el.dataset.finalWidth && el.dataset.finalWidth * 1) {
            el.style.width = el.dataset.finalWidth + 'px';
            el.style.marginRight = -(el.dataset.finalWidth - el.dataset.interWidth) + (el.dataset.finalMarginRight * 1) + 'px';
          }

          if (el.dataset.origHeight - el.dataset.finalHeight && el.dataset.finalHeight * 1) {
            el.style.height = el.dataset.finalHeight + 'px';
            el.style.marginBottom = -(el.dataset.finalHeight - el.dataset.interHeight) + (el.dataset.finalMarginBottom * 1) + 'px';
          }
        }
      }

      if (self._changingClass) {
        self._$container
          .removeClass(self.layout.containerClass)
          .addClass(self._newClass);
      }

      for (var i = 0; i < self._$toHide.length; i++) {
        var el = self._$toHide[i],
          $el = $(el),
          delay = self._getDelay(i),
          toHideCSS = {};

        for (var j = 0; j < 2; j++) {
          var a = j === 0 ? a = self._prefix : '';

          toHideCSS[a + 'transition-delay'] = delay + 'ms';
          toHideCSS[a + 'transform'] = self.effects.transformOut;
          toHideCSS.opacity = self.effects.opacity;
        }

        $el.css(self.effects.transition).css(toHideCSS);

        if (self.effects.transform || self.effects.opacity) {
          self._bindTargetDone($el);
        };
      }

      self._execAction('_animateTargets', 1);

    },

    /**
     * Bind Targets TransitionEnd
     * @since 2.0.0
     * @param {object} $el
     */

    _bindTargetDone: function($el) {
      var self = this,
        el = $el[0];

      self._execAction('_bindTargetDone', 0, arguments);

      if (!el.dataset.bound) {

        el.dataset.bound = true;
        self._targetsBound++;

        $el.on('webkitTransitionEnd.mixItUp transitionend.mixItUp', function(e) {
          if (
            (e.originalEvent.propertyName.indexOf('transform') > -1 ||
              e.originalEvent.propertyName.indexOf('opacity') > -1) &&
            $(e.originalEvent.target).is(self.selectors.target)
          ) {
            $el.off('.mixItUp');
            el.dataset.bound = '';
            self._targetDone();
          }
        });
      }

      self._execAction('_bindTargetDone', 1, arguments);
    },

    /**
     * Target Done
     * @since 2.0.0
     */

    _targetDone: function() {
      var self = this;

      self._execAction('_targetDone', 0);

      self._targetsDone++;

      (self._targetsDone === self._targetsBound) && self._cleanUp();

      self._execAction('_targetDone', 1);
    },

    /**
     * Clean Up
     * @since 2.0.0
     */

    _cleanUp: function() {
      var self = this,
        targetStyles = self.animation.animateResizeTargets ?
        'transform opacity width height margin-bottom margin-right' :
        'transform opacity',
        unBrake = function() {
          self._$targets.removeStyle('transition', self._prefix);
        };

      self._execAction('_cleanUp', 0);

      !self._changingLayout ?
        self._$show.css('display', self.layout.display) :
        self._$show.css('display', self._newDisplay);

      self._$targets.css(self._brake);

      self._$targets
        .removeStyle(targetStyles, self._prefix)
        .removeAttr('data-inter-pos-x data-inter-pos-y data-final-pos-x data-final-pos-y data-orig-pos-x data-orig-pos-y data-orig-height data-orig-width data-final-height data-final-width data-inter-width data-inter-height data-orig-margin-right data-orig-margin-bottom data-inter-margin-right data-inter-margin-bottom data-final-margin-right data-final-margin-bottom');

      self._$hide.removeStyle('display');

      self._$parent.removeStyle('height transition perspective-distance perspective perspective-origin-x perspective-origin-y perspective-origin perspectiveOrigin', self._prefix);

      if (self._sorting) {
        self._printSort();
        self._activeSort = self._newSortString;
        self._sorting = false;
      }

      if (self._changingLayout) {
        if (self._changingDisplay) {
          self.layout.display = self._newDisplay;
          self._changingDisplay = false;
        }

        if (self._changingClass) {
          self._$parent.removeClass(self.layout.containerClass).addClass(self._newClass);
          self.layout.containerClass = self._newClass;
          self._changingClass = false;
        }

        self._changingLayout = false;
      }

      self._refresh();

      self._buildState();

      if (self._state.fail) {
        self._$container.addClass(self.layout.containerClassFail);
      }

      self._$show = $();
      self._$hide = $();

      if (window.requestAnimationFrame) {
        requestAnimationFrame(unBrake);
      }

      self._mixing = false;

      if (typeof self.callbacks._user === 'function') {
        self.callbacks._user.call(self._domNode, self._state, self);
      }

      if (typeof self.callbacks.onMixEnd === 'function') {
        self.callbacks.onMixEnd.call(self._domNode, self._state, self);
      }

      self._$container.trigger('mixEnd', [self._state, self]);

      if (self._state.fail) {
        (typeof self.callbacks.onMixFail === 'function') && self.callbacks.onMixFail.call(self._domNode, self._state, self);
        self._$container.trigger('mixFail', [self._state, self]);
      }

      if (self._loading) {
        (typeof self.callbacks.onMixLoad === 'function') && self.callbacks.onMixLoad.call(self._domNode, self._state, self);
        self._$container.trigger('mixLoad', [self._state, self]);
      }

      if (self._queue.length) {
        self._execAction('_queue', 0);

        self.multiMix(self._queue[0][0], self._queue[0][1], self._queue[0][2]);
        self._queue.splice(0, 1);
      }

      self._execAction('_cleanUp', 1);

      self._loading = false;
    },

    /**
     * Get Prefixed CSS
     * @since 2.0.0
     * @param {string} property
     * @param {string} value
     * @param {boolean} prefixValue
     * @return {object} styles
     */

    _getPrefixedCSS: function(property, value, prefixValue) {
      var self = this,
        styles = {},
        prefix = '',
        i = -1;

      for (i = 0; i < 2; i++) {
        prefix = i === 0 ? self._prefix : '';
        prefixValue ? styles[prefix + property] = prefix + value : styles[prefix + property] = value;
      }

      return self._execFilter('_getPrefixedCSS', styles, arguments);
    },

    /**
     * Get Delay
     * @since 2.0.0
     * @param {number} i
     * @return {number} delay
     */

    _getDelay: function(i) {
      var self = this,
        n = typeof self.animation.staggerSequence === 'function' ? self.animation.staggerSequence.call(self._domNode, i, self._state) : i,
        delay = self.animation.stagger ? n * self.animation.staggerDuration : 0;

      return self._execFilter('_getDelay', delay, arguments);
    },

    /**
     * Parse MultiMix Arguments
     * @since 2.0.0
     * @param {array} args
     * @return {object} output
     */

    _parseMultiMixArgs: function(args) {
      var self = this,
        output = {
          command: null,
          animate: self.animation.enable,
          callback: null
        };

      for (var i = 0; i < args.length; i++) {
        var arg = args[i];

        if (arg !== null) {
          if (typeof arg === 'object' || typeof arg === 'string') {
            output.command = arg;
          } else if (typeof arg === 'boolean') {
            output.animate = arg;
          } else if (typeof arg === 'function') {
            output.callback = arg;
          }
        }
      }

      return self._execFilter('_parseMultiMixArgs', output, arguments);
    },

    /**
     * Parse Insert Arguments
     * @since 2.0.0
     * @param {array} args
     * @return {object} output
     */

    _parseInsertArgs: function(args) {
      var self = this,
        output = {
          index: 0,
          $object: $(),
          multiMix: {
            filter: self._state.activeFilter
          },
          callback: null
        };

      for (var i = 0; i < args.length; i++) {
        var arg = args[i];

        if (typeof arg === 'number') {
          output.index = arg;
        } else if (typeof arg === 'object' && arg instanceof $) {
          output.$object = arg;
        } else if (typeof arg === 'object' && self._helpers._isElement(arg)) {
          output.$object = $(arg);
        } else if (typeof arg === 'object' && arg !== null) {
          output.multiMix = arg;
        } else if (typeof arg === 'boolean' && !arg) {
          output.multiMix = false;
        } else if (typeof arg === 'function') {
          output.callback = arg;
        }
      }

      return self._execFilter('_parseInsertArgs', output, arguments);
    },

    /**
     * Execute Action
     * @since 2.0.0
     * @param {string} methodName
     * @param {boolean} isPost
     * @param {array} args
     */

    _execAction: function(methodName, isPost, args) {
      var self = this,
        context = isPost ? 'post' : 'pre';

      if (!self._actions.isEmptyObject && self._actions.hasOwnProperty(methodName)) {
        for (var key in self._actions[methodName][context]) {
          self._actions[methodName][context][key].call(self, args);
        }
      }
    },

    /**
     * Execute Filter
     * @since 2.0.0
     * @param {string} methodName
     * @param {mixed} value
     * @return {mixed} value
     */

    _execFilter: function(methodName, value, args) {
      var self = this;

      if (!self._filters.isEmptyObject && self._filters.hasOwnProperty(methodName)) {
        for (var key in self._filters[methodName]) {
          return self._filters[methodName][key].call(self, args);
        }
      } else {
        return value;
      }
    },

    /* Helpers
    ---------------------------------------------------------------------- */

    _helpers: {

      /**
       * CamelCase
       * @since 2.0.0
       * @param {string}
       * @return {string}
       */

      _camelCase: function(string) {
        return string.replace(/-([a-z])/g, function(g) {
          return g[1].toUpperCase();
        });
      },

      /**
       * Is Element
       * @since 2.1.3
       * @param {object} element to test
       * @return {boolean}
       */

      _isElement: function(el) {
        if (window.HTMLElement) {
          return el instanceof HTMLElement;
        } else {
          return (
            el !== null &&
            el.nodeType === 1 &&
            el.nodeName === 'string'
          );
        }
      }
    },

    /* Public Methods
    ---------------------------------------------------------------------- */

    /**
     * Is Mixing
     * @since 2.0.0
     * @return {boolean}
     */

    isMixing: function() {
      var self = this;

      return self._execFilter('isMixing', self._mixing);
    },

    /**
     * Filter (public)
     * @since 2.0.0
     * @param {array} arguments
     */

    filter: function() {
      var self = this,
        args = self._parseMultiMixArgs(arguments);

      self._clicking && (self._toggleString = '');

      self.multiMix({
        filter: args.command
      }, args.animate, args.callback);
    },

    /**
     * Sort (public)
     * @since 2.0.0
     * @param {array} arguments
     */

    sort: function() {
      var self = this,
        args = self._parseMultiMixArgs(arguments);

      self.multiMix({
        sort: args.command
      }, args.animate, args.callback);
    },

    /**
     * Change Layout (public)
     * @since 2.0.0
     * @param {array} arguments
     */

    changeLayout: function() {
      var self = this,
        args = self._parseMultiMixArgs(arguments);

      self.multiMix({
        changeLayout: args.command
      }, args.animate, args.callback);
    },

    /**
     * MultiMix
     * @since 2.0.0
     * @param {array} arguments
     */

    multiMix: function() {
      var self = this,
        args = self._parseMultiMixArgs(arguments);

      self._execAction('multiMix', 0, arguments);

      if (!self._mixing) {
        if (self.controls.enable && !self._clicking) {
          self.controls.toggleFilterButtons && self._buildToggleArray();
          self._updateControls(args.command, self.controls.toggleFilterButtons);
        }

        (self._queue.length < 2) && (self._clicking = false);

        delete self.callbacks._user;
        if (args.callback) self.callbacks._user = args.callback;

        var sort = args.command.sort,
          filter = args.command.filter,
          changeLayout = args.command.changeLayout;

        self._refresh();

        if (sort) {
          self._newSort = self._parseSort(sort);
          self._newSortString = sort;

          self._sorting = true;
          self._sort();
        }

        if (filter !== undf) {
          filter = (filter === 'all') ? self.selectors.target : filter;

          self._activeFilter = filter;
        }

        self._filter();

        if (changeLayout) {
          self._newDisplay = (typeof changeLayout === 'string') ? changeLayout : changeLayout.display || self.layout.display;
          self._newClass = changeLayout.containerClass || '';

          if (
            self._newDisplay !== self.layout.display ||
            self._newClass !== self.layout.containerClass
          ) {
            self._changingLayout = true;

            self._changingClass = (self._newClass !== self.layout.containerClass);
            self._changingDisplay = (self._newDisplay !== self.layout.display);
          }
        }

        self._$targets.css(self._brake);

        self._goMix(args.animate ^ self.animation.enable ? args.animate : self.animation.enable);

        self._execAction('multiMix', 1, arguments);

      } else {
        if (self.animation.queue && self._queue.length < self.animation.queueLimit) {
          self._queue.push(arguments);

          (self.controls.enable && !self._clicking) && self._updateControls(args.command);

          self._execAction('multiMixQueue', 1, arguments);

        } else {
          if (typeof self.callbacks.onMixBusy === 'function') {
            self.callbacks.onMixBusy.call(self._domNode, self._state, self);
          }
          self._$container.trigger('mixBusy', [self._state, self]);

          self._execAction('multiMixBusy', 1, arguments);
        }
      }
    },

    /**
     * Insert
     * @since 2.0.0
     * @param {array} arguments
     */

    insert: function() {
      var self = this,
        args = self._parseInsertArgs(arguments),
        callback = (typeof args.callback === 'function') ? args.callback : null,
        frag = document.createDocumentFragment(),
        target = (function() {
          self._refresh();

          if (self._$targets.length) {
            return (args.index < self._$targets.length || !self._$targets.length) ?
              self._$targets[args.index] :
              self._$targets[self._$targets.length - 1].nextElementSibling;
          } else {
            return self._$parent[0].children[0];
          }
        })();

      self._execAction('insert', 0, arguments);

      if (args.$object) {
        for (var i = 0; i < args.$object.length; i++) {
          var el = args.$object[i];

          frag.appendChild(el);
          frag.appendChild(document.createTextNode(' '));
        }

        self._$parent[0].insertBefore(frag, target);
      }

      self._execAction('insert', 1, arguments);

      if (typeof args.multiMix === 'object') {
        self.multiMix(args.multiMix, callback);
      }
    },

    /**
     * Prepend
     * @since 2.0.0
     * @param {array} arguments
     */

    prepend: function() {
      var self = this,
        args = self._parseInsertArgs(arguments);

      self.insert(0, args.$object, args.multiMix, args.callback);
    },

    /**
     * Append
     * @since 2.0.0
     * @param {array} arguments
     */

    append: function() {
      var self = this,
        args = self._parseInsertArgs(arguments);

      self.insert(self._state.totalTargets, args.$object, args.multiMix, args.callback);
    },

    /**
     * Get Option
     * @since 2.0.0
     * @param {string} string
     * @return {mixed} value
     */

    getOption: function(string) {
      var self = this,
        getProperty = function(obj, prop) {
          var parts = prop.split('.'),
            last = parts.pop(),
            l = parts.length,
            i = 1,
            current = parts[0] || prop;

          while ((obj = obj[current]) && i < l) {
            current = parts[i];
            i++;
          }

          if (obj !== undf) {
            return obj[last] !== undf ? obj[last] : obj;
          }
        };

      return string ? self._execFilter('getOption', getProperty(self, string), arguments) : self;
    },

    /**
     * Set Options
     * @since 2.0.0
     * @param {object} config
     */

    setOptions: function(config) {
      var self = this;

      self._execAction('setOptions', 0, arguments);

      typeof config === 'object' && $.extend(true, self, config);

      self._execAction('setOptions', 1, arguments);
    },

    /**
     * Get State
     * @since 2.0.0
     * @return {object} state
     */

    getState: function() {
      var self = this;

      return self._execFilter('getState', self._state, self);
    },

    /**
     * Force Refresh
     * @since 2.1.2
     */

    forceRefresh: function() {
      var self = this;

      self._refresh(false, true);
    },

    /**
     * Destroy
     * @since 2.0.0
     * @param {boolean} hideAll
     */

    destroy: function(hideAll) {
      var self = this,
        filters = $.MixItUp.prototype._bound._filter,
        sorts = $.MixItUp.prototype._bound._sort;

      self._execAction('destroy', 0, arguments);

      self._$body
        .add($(self.selectors.sort))
        .add($(self.selectors.filter))
        .off('.mixItUp');

      for (var i = 0; i < self._$targets.length; i++) {
        var target = self._$targets[i];

        hideAll && (target.style.display = '');

        delete target.mixParent;
      }

      self._execAction('destroy', 1, arguments);

      if (filters[self.selectors.filter] && filters[self.selectors.filter] > 1) {
        filters[self.selectors.filter]--;
      } else if (filters[self.selectors.filter] === 1) {
        delete filters[self.selectors.filter];
      }

      if (sorts[self.selectors.sort] && sorts[self.selectors.sort] > 1) {
        sorts[self.selectors.sort]--;
      } else if (sorts[self.selectors.sort] === 1) {
        delete sorts[self.selectors.sort];
      }

      delete $.MixItUp.prototype._instances[self._id];
    }

  };

  /* jQuery Methods
  ---------------------------------------------------------------------- */

  /**
   * jQuery .mixItUp() method
   * @since 2.0.0
   * @extends $.fn
   */

  $.fn.mixItUp = function() {
    var args = arguments,
      dataReturn = [],
      eachReturn,
      _instantiate = function(domNode, settings) {
        var instance = new $.MixItUp(),
          rand = function() {
            return ('00000' + (Math.random() * 16777216 << 0).toString(16)).substr(-6).toUpperCase();
          };

        instance._execAction('_instantiate', 0, arguments);

        domNode.id = !domNode.id ? 'MixItUp' + rand() : domNode.id;

        if (!instance._instances[domNode.id]) {
          instance._instances[domNode.id] = instance;
          instance._init(domNode, settings);
        }

        instance._execAction('_instantiate', 1, arguments);
      };

    eachReturn = this.each(function() {
      if (args && typeof args[0] === 'string') {
        var instance = $.MixItUp.prototype._instances[this.id];
        if (args[0] === 'isLoaded') {
          dataReturn.push(instance ? true : false);
        } else {
          var data = instance[args[0]](args[1], args[2], args[3]);
          if (data !== undf) dataReturn.push(data);
        }
      } else {
        _instantiate(this, args[0]);
      }
    });

    if (dataReturn.length) {
      return dataReturn.length > 1 ? dataReturn : dataReturn[0];
    } else {
      return eachReturn;
    }
  };

  /**
   * jQuery .removeStyle() method
   * @since 2.0.0
   * @extends $.fn
   */

  $.fn.removeStyle = function(style, prefix) {
    prefix = prefix ? prefix : '';

    return this.each(function() {
      var el = this,
        styles = style.split(' ');

      for (var i = 0; i < styles.length; i++) {
        for (var j = 0; j < 4; j++) {
          switch (j) {
            case 0:
              var prop = styles[i];
              break;
            case 1:
              var prop = $.MixItUp.prototype._helpers._camelCase(prop);
              break;
            case 2:
              var prop = prefix + styles[i];
              break;
            case 3:
              var prop = $.MixItUp.prototype._helpers._camelCase(prefix + styles[i]);
          }

          if (
            el.style[prop] !== undf &&
            typeof el.style[prop] !== 'unknown' &&
            el.style[prop].length > 0
          ) {
            el.style[prop] = '';
          }

          if (!prefix && j === 1) break;
        }
      }

      if (el.attributes && el.attributes.style && el.attributes.style !== undf && el.attributes.style.value === '') {
        el.attributes.removeNamedItem('style');
      }
    });
  };

})(jQuery);

(function($) {

  var $window = $(window);


  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {

      // GENERAL
      window: window,
      document: document,
      html: 'html',
      body: 'body',
      header: 'header',
      footer: 'footer',

      // BACK TO TOP
      back_to_top: '.back-to-top',
      stop_propagation: '.stop-propagation'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      _scroll_to: function(position, duration) {

        self.elements.body.add(self.elements.html).animate({
          scrollTop: position
        }, {
          duration: duration,
          easing: 'easeOutQuint'
        });

      },
      _back_to_top: function(event) {

        event.preventDefault();

        self.methods._scroll_to(0, 550);

      },
      _keydown_events: function(e) {

        var keycode = e.keyCode;

        switch (keycode) {
          // ESC
          case 27:
            self.elements.body.trigger(window.object_name + '.html_esc');
            break;
        }

      },
      _html_click_events: function() {
        self.elements.window.trigger(window.object_name + '.html_click', self);

      },
      _stop_propagation: function(e) {

        e.stopPropagation();

      },
      _css_transition_duration: function($element) {
        return parseFloat($element.css('transition-duration'), 10) * 1000;
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {

      // BACK TO TOP
      'click._back_to_top': {
        element: self.elements.back_to_top,
        action: self.methods._back_to_top
      },
      'keydown._keydown_events': {
        element: self.elements.html,
        action: self.methods._keydown_events
      },
      'click._html_click_events': {
        element: self.elements.html,
        action: self.methods._html_click_events
      }

    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    self.elements.body.delegate('.stop-propagation', 'click._stop_propagation', self.methods._stop_propagation);
  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      foo: 'body'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      mobile: {
        _is_browser_mobile: function() {
          var check = false;
          (function(a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
              check = true;
            }
          })(navigator.userAgent || navigator.vendor || window.opera);
          return check;
        },
        _set_mobile: function() {
          var is_mobile = self.methods.mobile._is_browser_mobile();
          if (is_mobile) {
            $('body').addClass('mobile');
          } else {
            $('body').removeClass('mobile');
          }
        },
        _is_mobile: function(width) {

          if (!width) {

            var body = typeof self.elements.body !== 'object' ? $('body') : self.elements.body;

            if (body.hasClass('mobile')) {
              return true;
            }

          }

          width = width ? width : 320;

          if (window.innerWidth <= width) {
            return true;
          } else {
            return false;
          }

        },
        _is_width: function(size, larger_smaller) {

          size = size ? size : 991;
          larger_smaller = larger_smaller ? larger_smaller : 'smaller';

          switch (size) {
            case 'screen-lg':
              size = 1200;
              break;
            case 'screen-md':
              size = 992;
              break;
            case 'screen-sm':
              size = 768;
              break;
            case 'screen-xs':
              size = 480;
              break;
            default:
              size = 480;
              break;
          }

          switch (larger_smaller) {
            case 'larger':
              if (window.innerWidth > size) {
                return true;
              }
              break;
            case 'smaller':
              if (window.innerWidth < size) {
                return true;
              }
              break;
            default:
              if (window.innerWidth < size) {
                return true;
              }
              break;
          }

          return false;

        }


      }
    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    // Determine if this is a mobile browser
    self.methods.mobile._set_mobile();
  });

})(jQuery);

// REVIEWS DROPDOWN

(function($) {

  var $window = $(window);


  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      reviews_open: '[data-action="reviews-open"]',
      reviews_close: '[data-action="reviews-close"]',
      reviews_toggle: '[data-action="reviews-toggle"]',
      review_holder: '.purchase-bar'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      reviews: {
        _open: function() {
          self.elements.review_holder.addClass('reviews-open');

        },
        // _close: function() {
        //   $('a.nav-reviews').text('Reviews');
        //   self.elements.review_holder.removeClass('reviews-open');
        // },
        _toggle: function() {
          $('.purchase-bar').attr("class").split(' ');
          self.elements.review_holder.toggleClass('reviews-open');

        }
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'click.reviews._open': {
        element: self.elements.reviews_open,
        action: self.methods.reviews._open
      },
      'click.reviews._close': {
        element: self.elements.reviews_close,
        action: self.methods.reviews._close
      },
      'click.reviews._toggle': {
        element: self.elements.reviews_toggle,
        action: self.methods.reviews._toggle
      }
    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    var $pbar = $('.purchase-bar'),
      $navReviews = $('a.nav-reviews');

    $navReviews.click(function() {
      if ($pbar.hasClass('reviews-open')) {
        $navReviews.text('CLOSE');
      } else {
        $navReviews.text('Reviews');
      }
    });
  });

})(jQuery);



(function($) {

  var $window = $(window);


  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      scrolling: '[data-scroll="true"]',
      nav_offset: 'nav.main-navigation',
      top_banner_offset: '.top-banner'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      scroll: {
        _adjust: function() {
          var $fixed_elements = $('.scrolling'),
            offset = self.elements.nav_offset.outerHeight();
            if (self.elements.top_banner_offset.length) {
              offset += self.elements.top_banner_offset.outerHeight();
            }

          self.elements.scrolling.each(function() {
            var $this = $(this),
              $stop_element = $($this.data('scroll-stop')),
              stop = $stop_element.offset().top,
              beyond_start = window.scrollY + offset > $this.offset().top ? true : false,
              above_start = window.scrollY + offset < $this.offset().top ? true : false;

            if ($this.is('.sidebar')) {

              var $aside = $this.find('aside'),
                aside_height = $aside.outerHeight(),
                above_stop = (aside_height + window.scrollY + offset) <= stop ? true : false,
                beyond_stop = (aside_height + window.scrollY + offset) > stop ? true : false,
                move_to = 0;


              if (beyond_start && above_stop) {
                move_to = window.scrollY - $this.offset().top + offset;
              } else if (beyond_stop) {
                move_to = stop - aside_height - $this.offset().top;
              }


              setTimeout(function() {
                $aside.css({
                  '-webkit-transform': 'translate3d(0px,' + move_to + 'px,0px)',
                  '-moz-transform': 'translate3d(0px,' + move_to + 'px,0px)',
                  '-ms-transform': 'translate3d(0px,' + move_to + 'px,0px)',
                  '-o-transform': 'translate3d(0px,' + move_to + 'px,0px)',
                  'transform': 'translate3d(0px,' + move_to + 'px,0px)'
                });
              }, 100);
            }

            if ($this.is('.purchase-bar')) {
              if (beyond_start) {
                $this.addClass('fixed');
              } else {
                $this.removeClass('fixed');
              }
            }
          });

        }
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {
    if ($window.width() > 992) {
      self.methods._add('events', {
        'scroll._adjust': {
          event: 'scroll.scroll._adjust',
          element: self.elements.window,
          action: self.methods.scroll._adjust
        },
        'resize._adjust': {
          event: 'resize.scroll._adjust',
          element: self.elements.window,
          action: self.methods.scroll._adjust
        }
      });
    }
  });


  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    self.methods.scroll._adjust();
  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      master_col: '.master-col',
      slave_col: '.slave-col',
      balance: '[data-layout="balance"]'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      align_cols: function() {

        self.elements.slave_col.each(function() {

          var $slave = $(this),
            $master = $slave.next('.master-col');

          if (!$master.length) {
            $master = $slave.prev('.master-col');
          }

          if (!$master.length) {
            return;
          }

          if ($slave.parents('.row').hasClass('no-mobile-adjust') && self.methods.mobile._is_mobile(992)) {
            $slave.removeAttr('style');
            return;
          }

          $slave.css('height', $master.outerHeight());
        });
      },
      balance_cols: function() {

        self.elements.balance.each(function() {

          var $this = $(this),
            $cols = $this.children('[data-layout="col"]');

          $cols.css('height', '');

          if ($this.hasClass('no-mobile-adjust') && self.methods.mobile._is_mobile(992)) {
            return;
          }

          $cols.css('height', parseInt($this.innerHeight(), 10) - parseInt($this.css('paddingTop'), 10));

        });

      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'align_cols': {
        element: self.elements.window,
        action: self.methods.align_cols
      },
      'resize.lineup_discover_cols': {
        element: self.elements.window,
        action: self.methods.align_cols
      },
      'resize.balance_cols': {
        element: self.elements.window,
        action: self.methods.balance_cols
      }
    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    self.methods.align_cols();
    self.methods.balance_cols();

    window[window.object_name].properties.balance_timeout = setTimeout(function() {
      self.methods.align_cols();
      self.methods.balance_cols();
    }, 5000);

    window[window.object_name].properties.balance_interval_c = 0;
    window[window.object_name].properties.balance_interval = setTimeout(function() {
      self.methods.align_cols();
      self.methods.balance_cols();
      window[window.object_name].properties.balance_interval_c++;
      if (window[window.object_name].properties.balance_interval_c > 10) {
        clearInterval(window[window.object_name].properties.balance_interval);
      }
    }, 100);

  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      purchase_bar_height: '.purchase-bar',
      smooth_scroll: 'a[href*="#"]',
      scroll_links: '.scroll-links a[href*="#"]',
      smooth_scroll_sections: '*[id]:not(path, g, mask, svg, polygon, input, radialgradient, text)'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {
    window[window.object_name].properties.smooth_scroll = null;
    window[window.object_name].properties.smooth_scroll_timeout = null;
    self.methods._add('methods', {
      smooth_scroll: function(e) {

        var $link = $(this),
          href = $link.attr('href');

        if (href.indexOf('#') !== 0) {
          return;
        }

        e.preventDefault();

        var $anchor = $(href),
          offset = -self.elements.nav.outerHeight() + 1;

        if (self.elements.purchase_bar_height.length) {
          offset -= self.elements.purchase_bar_height.outerHeight();
        }

        if ($anchor.length) {
          var scrollTo = $anchor.offset().top + offset;
          $("html, body").animate({
            scrollTop: scrollTo
          }, 500);
          window[window.object_name].properties.smooth_scroll = true;
          window[window.object_name].properties.smooth_scroll_timeout = setTimeout(function() {
            window[window.object_name].properties.smooth_scroll = true;
          }, 500);
        }

      },
      stop_smooth_scroll: function(e) {
        if (window[window.object_name].properties.smooth_scroll) {
          if (e.which > 0 || e.type === "mousedown" || e.type === "mousewheel") {
            $("html, body").stop();
            window[window.object_name].properties.smooth_scroll = false;
            if (window[window.object_name].properties.smooth_scroll_timeout) {
              clearTimeout(window[window.object_name].properties.smooth_scroll_timeout);
            }
          }
        }
      },
      update_scroll_links: function() {

        if (window[window.object_name].properties.smooth_scroll) {
          return;
        }

        var offset = -self.elements.nav.outerHeight() - 1,
          current_section = null;

        if (self.elements.purchase_bar_height.length) {
          offset -= self.elements.purchase_bar_height.outerHeight();
        }

        var scroll_pos = window.scrollY - offset;

        self.elements.smooth_scroll_sections.each(function() {
          var $this = $(this),
            id = this.id,
            top = $this.offset().top,
            height = $this.outerHeight();

          if (scroll_pos >= top && scroll_pos <= top + height) {
            current_section = '#' + id;
          }
        });

        var $current_link = self.elements.scroll_links.filter('[href="' + current_section + '"]');
        if ($current_link.length) {
          self.elements.scroll_links.not($current_link).removeClass('active');
          $current_link.addClass('active');
        }

      },
      click_scroll_link: function() {
        var $this = $(this);

        self.elements.scroll_links.not($this).removeClass('active');

        $this.addClass('active');
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'click.smooth_scroll': {
        event: 'click.smooth_scroll',
        element: self.elements.smooth_scroll,
        action: self.methods.smooth_scroll
      },
      'stop_smooth_scroll': {
        event: 'scroll mousedown DOMMouseScroll mousewheel keyup',
        element: self.elements.window,
        action: self.methods.stop_smooth_scroll
      },
      'update_scroll_links': {
        event: 'scroll.update_scroll_links',
        element: self.elements.window,
        action: self.methods.update_scroll_links
      },
      'click_scroll_link': {
        event: 'click.update_scroll_links',
        element: self.elements.scroll_links,
        action: self.methods.click_scroll_link
      }
    });

  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      jwplayer: '.jwplayer'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      jwplayer: {
        _jwplayer_load: function(options) {

          var defaults = {
            element: '',
            ID: '',
            file: '',
            image: '',
            width: '100%',
            controls: false,
            autostart: true,
            mute: true,
            stretching: 'fill',
            wmode: 'transparent',
            repeat: false
          };

          options = $.extend(true, defaults, options);

          if (!options.element.length || !options.ID.length) {
            return;
          }

          options.file = options.file.length ? options.file : options.element.data('media-url');
          options.image = options.image.length ? options.image : options.element.data('poster-url');
          window.jwplayer.key = '8rW/GU2sVQLRgw+vjsP35fkm48iBr+1gWVCNsA==';

          window.jwplayer(options.ID).setup(options);

        },
        _jwplayer_control: function(action, ID) {

          var jwplayer = window.jwplayer(ID);

          switch (action) {
            case 'play':
              jwplayer.play();
              break;
            case 'pause':
              jwplayer.pause();
              break;
            case 'stop':
              jwplayer.stop();
              break;
          }
        },
        _background_video: function() {
          if (self.methods.mobile._is_browser_mobile()) {
            return;
          }
          var background_videos = $('.background-video .jwplayer');
          if (background_videos.length) {
            background_videos.each(function() {
              var $this = $(this);
              self.methods.jwplayer._jwplayer_load({
                element: $this,
                ID: $this.attr('id'),
                repeat: true
              });
            });
          }

        }
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'close_hero_video_full_on_esc': {
        event: window.object_name + '.html_esc',
        element: self.elements.html,
        action: self.methods.vendors._close_hero_video
      }
    });

  });

  // RUNS WHEN HERO ELEMENT IS ON PAGE
  $window.on(window.object_name + '.jwplayer._background_video', function() {
    var self = window[window.object_name];
    self.methods.jwplayer._background_video();
  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      nav: 'nav',

      nav_items: 'nav .nav-items > li > a',
      nav_items_li: 'nav .nav-items > li',
      nav_utilties: 'nav .nav-bar .right',
      nav_dropdown: 'nav .nav-dropdown',
      nav_dropdown_items: 'nav .nav-dropdown > li',
      nav_dropdown_items_secondary: 'nav .nav-dropdown .nav-dropdown-secondary > li > a',
      nav_dropdown_items_preview: 'nav .nav-dropdown .nav-dropdown-preview > li',
      nav_dropdown_items_preview_inner: 'nav .nav-dropdown .nav-dropdown-preview > li .nav-dropdown-preview-inner',

      nav_search: 'nav .search',
      nav_search_open: '[data-action="search-open"]',
      nav_search_form: 'nav .search form',
      nav_search_submit: '[data-action="search-submit"]',
      nav_search_field: 'nav .search input[type="text"]',

      nav_more_dropdown: 'nav .more-dropdown',
      nav_more_dropdown_toggle: 'nav .more-dropdown > em',
      nav_more_dropdown_box: 'nav .more-dropdown-box',

      nav_mobile_dropdown: '.mobile-nav-dropdown',
      nav_mobile_toggle: '[data-action="nav-mobile-toggle"]',
      nav_mobile_hamburger: '.nav-bar .hamburger',
      nav_mobile_item_toggle: '.mobile-nav-items .toggle > .item-header',
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    window.close_nav_dropdown = null;
    window.hide_nav_item = null;
    window.hide_nav_preview = null;
    window.animate_nav_preview = null;
    window.close_search = null;

    self.methods._add('methods', {
      nav: {
        dropdown: {
          _open: function() {

            clearTimeout(window.close_nav_dropdown);
            clearTimeout(window.hide_nav_item);
            var $this = $(this),
              $nav_items = self.elements.nav_items.not('.no-dropdown'),
              this_index = $nav_items.index($this),
              $requested_nav = self.elements.nav_dropdown_items.eq(this_index);

            if ($this.hasClass('no-dropdown') || !$requested_nav.length) {
              self.methods.nav.dropdown._close();
              return;
            }

            self.methods.nav.dropdown_more._close();
            self.methods.nav.search._close();

            self.elements.nav_items.removeClass('active');

            self.elements.nav_items_li.removeClass('active');
            $this.parents('li').addClass('active');

            self.elements.nav_dropdown_items.hide();
            $requested_nav.show();
            self.elements.nav_dropdown.addClass('open');
          },
          _close: function() {
            self.elements.nav_dropdown.removeClass('open');
            self.elements.nav_items_li.removeClass('active');
            window.hide_nav_item = setTimeout(function() {
              self.elements.nav_dropdown_items.hide();
            }, self.methods._css_transition_duration(self.elements.nav_dropdown) + 10);
          },
          _leave: function() {
            window.close_nav_dropdown = setTimeout(function() {
              self.methods.nav.dropdown._close();
            }, 100);
          },
          _enter: function() {
            clearTimeout(window.close_nav_dropdown);
          },
          _preview: function() {

            clearTimeout(window.hide_nav_preview);
            // 									clearTimeout(window.animate_nav_preview);

            var $this = $(this),
              $this_nav = $this.parents('.nav-dropdown-secondary'),
              this_index = $this_nav.find('> li > a').index($this),
              $this_preview = $this_nav.next('.nav-dropdown-preview').children('li'),
              // Kenny Add + 1 to Index to allow preview to show in nav
              $requested_preview = $this_preview.eq(this_index + 1),
              $other_previews = $this_preview.not($requested_preview);

            $other_previews.removeClass('animate-in');

            window.hide_nav_preview = setTimeout(function() {
              $this_preview.not($requested_preview).removeClass('active');
            }, self.methods._css_transition_duration(self.elements.nav_dropdown_items_preview_inner) + 10);

            if ($requested_preview.length) {
              $requested_preview.addClass('active');

              window.animate_nav_preview = setTimeout(function() {
                $requested_preview.addClass('animate-in');
              }, 20);
            }
          }
        },
        search: {
          _open: function(e) {
            e.preventDefault();
            e.stopPropagation();

            clearTimeout(window.close_search);

            self.methods.nav.dropdown_more._close();
            self.methods.nav.dropdown._close();

            self.elements.nav_search.addClass('open');
            setTimeout(function() {
              self.elements.nav_search_field.focus();
            }, self.methods._css_transition_duration(self.elements.nav_search_field));
          },
          _close: function() {
            window.close_search = setTimeout(function() {
              self.elements.nav_search.removeClass('open');
            }, 100);

          },
          _blur: function() {
            self.elements.nav_search_field.trigger('blur.nav.search._close');
          },
          _submit: function(e) {
            e.preventDefault();
            if (self.elements.nav_search_field.val().length) {
              self.elements.nav_search_form.trigger('submit');
            } else {
              self.methods.nav.search._close();
            }
          }
        },
        dropdown_more: {
          _toggle: function() {
            self.methods.nav.dropdown._close();
            self.elements.nav_more_dropdown.toggleClass('open');
          },
          _close: function() {
            self.elements.nav_more_dropdown.removeClass('open');
          },
          _dynamic: function() {
            var cutoff = self.elements.nav_utilties.offset().left - 100,
              $dynamic_items = [];

            self.elements.nav_items_li.each(function() {
              var $this = $(this);
              if ($this.offset().left + $this.outerWidth(true) > cutoff) {
                $this.addClass('hide');
                $dynamic_items.push($this);
              } else {
                $this.removeClass('hide');
              }
            });

            var $dropdown_li = self.elements.nav_more_dropdown.find('ul.more-dropdown-box-items > li');

            $dropdown_li.not('.permanent').remove();

            if ($dynamic_items.length) {
              $dynamic_items = $dynamic_items.reverse();
              var $destination = self.elements.nav_more_dropdown.find('ul.more-dropdown-box-items');
              for (var item in $dynamic_items) {
                $('<li>' + $dynamic_items[item].html() + '</li>').prependTo($destination);
              }
            }

          }
        },
        mobile: {
          _toggle: function() {
            $('html').toggleClass('overflow-y-hidden');
            self.elements.nav_mobile_hamburger.toggleClass('open');
            self.elements.nav_mobile_dropdown.toggleClass('open');
            if (!self.elements.nav_mobile_dropdown.hasClass('open')) {
              self.elements.nav_mobile_dropdown.find('*')
                .removeAttr('style')
                .removeClass('open up');
            }
          },
          _item_toggle: function() {
            var $this = $(this),
              $parent_item = $this.parents('li').first(),
              $sub_menu = $this.next('.mobile-nav-sub-items'),
              $sub_menu_ul = $sub_menu.children('ul'),
              sub_height = $sub_menu_ul.outerHeight(true);

            if (!$parent_item.hasClass('open')) {
              $parent_item.css('height', sub_height + 55).addClass('open');
              $sub_menu.css('height', sub_height);
              $this.parents('ul').first().children('li').not($parent_item).addClass('up');
            } else {
              $parent_item.removeAttr('style').removeClass('open');
              $sub_menu.removeAttr('style');
              $parent_item.parents('ul').children('li').removeClass('up');
            }
          }
        }
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {
    self.methods._add('events', {
      'nav.dropdown._open': {
        event: 'mouseenter.nav.dropdown._open',
        element: self.elements.nav_items,
        action: self.methods.nav.dropdown._open
      },
      'nav.dropdown._enter': {
        event: 'mouseenter.nav.dropdown._enter',
        element: self.elements.nav,
        action: self.methods.nav.dropdown._enter
      },
      'nav.dropdown._leave': {
        event: 'mouseleave.nav.dropdown._leave',
        element: self.elements.nav,
        action: self.methods.nav.dropdown._leave
      },
      'nav.dropdown._close.esc': {
        event: window.object_name + '.html_esc',
        element: self.elements.window,
        action: self.methods.nav.dropdown._close
      },
      'nav.dropdown._preview': {
        event: 'mouseenter.nav.dropdown._preview',
        element: self.elements.nav_dropdown_items_secondary,
        action: self.methods.nav.dropdown._preview
      },
      'nav.search._open': {
        event: 'click.nav.search._open',
        element: self.elements.nav_search_open,
        action: self.methods.nav.search._open
      },
      'nav.search._submit': {
        event: 'click.nav.search._submit',
        element: self.elements.nav_search_submit,
        action: self.methods.nav.search._submit
      },
      'nav.search._close': {
        event: 'blur.nav.search._close',
        element: self.elements.nav_search_field,
        action: self.methods.nav.search._close
      },
      'nav.search._close.esc': {
        event: window.object_name + '.html_esc',
        element: self.elements.window,
        action: self.methods.nav.search._blur
      },
      'nav.dropdown_more._toggle': {
        event: 'click.nav.dropdown._toggle',
        element: self.elements.nav_more_dropdown_toggle,
        action: self.methods.nav.dropdown_more._toggle
      },
      'nav.dropdown_more._dynamic': {
        event: 'resize.nav.dropdown._dynamic',
        element: self.elements.window,
        action: self.methods.nav.dropdown_more._dynamic
      },
      'nav.mobile._toggle': {
        event: 'click.nav.mobile._toggle',
        element: self.elements.nav_mobile_toggle,
        action: self.methods.nav.mobile._toggle
      },
      'nav.mobile._toggle_item': {
        event: 'click.nav.mobile._item_toggle',
        element: self.elements.nav_mobile_item_toggle,
        action: self.methods.nav.mobile._item_toggle
      }
    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    self.methods.nav.dropdown_more._dynamic();

  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      cart: 'cart',
      cart_toggle: '[data-action="cart-toggle"]',
      cart_open: '[data-action="cart-open"]',
      cart_close: '[data-action="cart-close"]',
      cart_sidecar: '.cart-sidecar',
      cart_sidecar_overlay: '.cart-sidecar-overlay',
      cart_sidecar_promo: '.shipping-promo li',
      cart_review: '.cart-review',
      cart_review_cart_items: '.cart-review .cart-items',
      cart_review_cart_actions: '.cart-review .cart-actions',
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    window.cart_sidecar_animate_in = null;
    window.cart_sidecar_close = null;

    self.methods._add('methods', {
      cart: {
        _toggle: function() {
          if (!self.elements.body.hasClass('cart-open')) {
            self.methods.cart._open();
          } else {
            self.methods.cart._close();
          }
        },
        _open: function() {
          Scroll.lock();
          clearTimeout(window.cart_sidecar_close);

          self.methods.nav.dropdown_more._close();
          self.methods.nav.dropdown._close();
          self.methods.nav.search._close();

          self.elements.body.addClass('cart-open');

          if (typeof AddTax.getCountryCode() !== 'undefined') {
            var $price = $('.cart-sidecar [data-geolizr-price]');

            if ($price.length > 0 && GeolizrAPI && GeolizrAPI.api) {
              $price.each(function() {
                if (!$price.attr('data-price-changed')) {
                  $price.attr('data-price-changed', 'true')
                  AddTax.setPrice($price, 'data-geolizr-price');
                  GeolizrAPI.api.switchCurrency(GeolizrAPI.api.getCurrency());
                }
              });
            }
          }

          window.cart_sidecar_animate_in = setTimeout(function() {
            self.elements.cart_sidecar_overlay.addClass('animate-in');
          }, 25);
        },
        _close: function() {
          Scroll.unlock();
          clearTimeout(window.cart_sidecar_animate_in);
          self.elements.body.addClass('cart-close');
          window.cart_sidecar_close = setTimeout(function() {
            self.elements.body.removeClass('cart-open cart-close');
            self.elements.cart_sidecar_overlay.removeClass('animate-in');
          }, self.methods._css_transition_duration(self.elements.cart_sidecar));
        },
        _update_shipping_promo: function(current, max) {
          if (current >= max) {
            self.elements.cart_sidecar_promo.removeClass('active')
              .filter('.free-shipping').addClass('active');
          } else {
            self.elements.cart_sidecar_promo.removeClass('active')
              .filter('.no-free-shipping').addClass('active')
              .find('[data-edit="cart-promo-remaining"]').text('$' + (max - current).toFixed(2));
          }
        }
      },
      cart_review: {
        _resize: function() {
          if (self.methods.mobile._is_mobile(992)) {
            return;
          }

          if (self.elements.cart_review_cart_items.outerHeight() + 20 > self.elements.cart_review_cart_actions.outerHeight()) {
            self.elements.cart_review_cart_actions.addClass('align-top');
          } else {
            self.elements.cart_review_cart_actions.removeClass('align-top');
          }
        }
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'cart._toggle': {
        event: 'click.cart._toggle',
        element: self.elements.cart_toggle,
        action: self.methods.cart._toggle
      },
      'cart._open': {
        event: 'click.cart._open',
        element: self.elements.cart_open,
        action: self.methods.cart._open
      },
      'cart._close': {
        event: 'click.cart._close',
        element: self.elements.cart_close,
        action: self.methods.cart._close
      },
      'cart_review._resize': {
        event: 'resize.cart_review._resize',
        element: self.elements.window,
        action: self.methods.cart_review._resize
      }
    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    self.methods.cart_review._resize();
  });

})(jQuery);

(function($) {

  var $window = $(window);


  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      product_grid_items: '.products .grid .grid-item'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      grid: {
        _product_sizing: function(ratings) {
          var height = 0;

          $(self.elements.product_grid_items.selector).not('.no-js-height').each(function() {
            var $this = $(this),
              $grid_image = $this.find('.grid-image'),
              is_staggered_grid = $this.parents('.staggered-grid').length;

            if (is_staggered_grid) {
              $grid_image.css('position', 'relative');
            }

            $this.removeAttr('style');

            var this_height = $this.outerHeight();

            if (is_staggered_grid) {
              $grid_image.css('position', 'absolute');
            }

            if (this_height > height) {
              height = this_height;
            }

            if ($(window).width() < 420) {
              height -= 1;
            }
          }).css('height', height);

          if ($(self.elements.product_grid_items.selector).find('.ratings').length) {
            ratings.rl = $(self.elements.product_grid_items.selector).find('.ratings').length;
          }
        }
      }
    });
  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {
    self.methods._add('events', {
      'grid._product_sizing': {
        event: 'resize.grid._product_sizing',
        element: self.elements.window,
        action: self.methods.grid._product_sizing
      }
    });
  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    if ($('body').hasClass('template__collection--fleshlight-girls')) {
      self.methods.grid._product_sizing();
    } else {
      var ratings = {
        rl: 0
      };
      var currentRatingLength = 0;
      var interval = 0;

      var setProductSize = setInterval(function() {
        var first = false;
        self.methods.grid._product_sizing(ratings);
        if (ratings.rl > 0 && ratings.rl === currentRatingLength || interval > 5) {
          clearInterval(setProductSize);
        } else if (ratings.rl > 0) {
          currentRatingLength = ratings.rl;
        }
        interval += 1;
      }, 1000);
    }
  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      tab_nav: '.tab-nav > li',
      tabs: '.tabs-holder > .tabs'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      switch_tabs: function() {

        var $this_button = $(this),
          $this_tabs = $this_button.parents('.tabs'),
          $this_nav = $this_tabs.find('ul.tab-nav'),
          $all_buttons = $this_nav.children('li'),
          $tab_content = $this_tabs.find('.tabs-holder'),
          $all_tabs = $tab_content.children('.tab'),
          $requested_tab = $all_tabs.eq($all_buttons.index($this_button));

        if (!$requested_tab.length) {
          return;
        }

        $all_buttons.add($this_nav.find('div')).removeClass('active');
        $this_button.add($this_button.find('div')).addClass('active');

        $all_tabs.removeClass('active animate-in');
        $requested_tab.addClass('active animate-in');

      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'click.switch_tabs': {
        element: self.elements.tab_nav,
        action: self.methods.switch_tabs
      }
    });

  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      footer_menu_module: '.footer-menu-module',
      footer_menu_module_handle: '.footer-menu-module > strong',
      footer_menu_module_content: '.footer-menu-module .footer-links-wrap'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      footer: {
        _toggle: function() {
          var $this = $(this),
            $footer_menu = $this.parents('.footer-menu-module'),
            $content = $footer_menu.find('.footer-links-wrap'),
            $content_inner = $content.find('ul');

          self.elements.footer_menu_module.not($footer_menu).removeClass('open');
          self.elements.footer_menu_module_content.not($content).css('height', 0);

          $footer_menu.toggleClass('open');

          if ($footer_menu.hasClass('open')) {
            $content.css('height', $content_inner.outerHeight(true));
          } else {
            $content.css('height', 0);
          }
        }
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'footer._toggle': {
        event: 'click.footer._toggle',
        element: self.elements.footer_menu_module_handle,
        action: self.methods.footer._toggle
      }
    });

  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      modals: '.modals',
      modal: '.modals .modal',
      modal_open: '[data-action="modal-open"]',
      modal_close: '[data-action="modal-close"]'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    window.user_engagement = false;

    self.methods._add('methods', {
      modals: {
        _open: function(event, modal) {

          window.user_engagement = true;

          var $modal = null;
          var customVideoUrl = null;

          if (typeof modal === 'undefined') {

            var $this = $(this);

            modal = $this.data('modal');
            customVideoUrl = $this.data('custom-url');

            if (!modal) {
              return;
            }

          }


          $modal = self.elements.modal.filter('#' + modal);

          if (!$modal.length) {
            return;
          }

          var open_modals = self.elements.modal.filter('.open').length;

          if (open_modals) {
            self.methods.modals._close();
            setTimeout(function() {
              self.methods.modals._animate_open($modal);
            }, 510);
          } else {
            self.methods.modals._animate_open($modal);
            if ($modal.hasClass('video')) {
              var $iframe = $modal.find('iframe'),
                url = $iframe.data('url');

              if(customVideoUrl) {
                url = customVideoUrl;
              }

              $iframe.attr('src', url);
            }
          }

        },
        _animate_open: function($modal) {

          self.elements.modals.css('display', 'block');

          setTimeout(function() {
            self.elements.body.addClass('modal-open');
            $modal.addClass('open');
            self.methods.align_cols();
          }, 50);
        },
        _close: function() {

          self.elements.body.removeClass('modal-open');

          setTimeout(function() {
            self.elements.modals.css('display', 'none');
            self.elements.modal.removeClass('open');
            var $video_modals = self.elements.modal.filter('.video');
            if ($video_modals.length) {
              $video_modals.find('iframe').attr('src', '');
            }
          }, 300);
        },
        _auto_display: function() {

          var modal_displayed_cookie = Boolean(window.Cookies.get('modal_displayed'));

          if (!modal_displayed_cookie) {

            window.Cookies.set('modal_displayed', true);

            self.methods.modals._open('', self.elements.modal.filter('#free-shipping'));
          }
        }
      }

    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'modals._open': {
        event: 'click.modals._open',
        delegate: $('body'),
        element: self.elements.modal_open,
        action: self.methods.modals._open
      },
      'click.close_modal': {
        element: self.elements.modal_close,
        action: self.methods.modals._close
      },
      'esc_close_modal': {
        event: window.object_name + '.html_esc',
        element: self.elements.body,
        action: self.methods.modals._close
      }
    });

  });


  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {

    if (window.location.hash) {
      if ($('.modals ' + window.location.hash).length) {
        self.methods.open_modal(null, $(window.location.hash));
      }
    }
  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      sliders: '.slider',
      case_study_slider: '.case-study-slider',
      case_study_slider_toggle: '[data-action="case-study-slider-toggle"]',
      case_study_slider_wrap: 'section.case-studies',
      arrow_svg: '.arrow-svg'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      slider: {
        _init: function() {

          if (!self.elements.sliders.length) {
            return;
          }

          self.elements.sliders.each(function() {
            var $this = $(this),
              options = {
                'items': 1,
                'loop': true,
                'pagination': true,
                'nav': true,
                'navSpeed': 500,
                'smartSpeed': 500,
                'responsiveRefreshRate': 1,
                'navText': [
                  '\uf053',
                  '\uf054'
                ]
              };
            if ($this.hasClass('full-width-items')) {
              options.center = true;
              options.items = 8;
              options.autoWidth = true;
              if ($this.hasClass('items-left')) {
                options.center = false;
              }
            }

            if ($this.hasClass('sociel-proof-sliderr')) {
              options.navigation = true;
              options.dotsContainer = '.social-proof-dots';
            }

            if ($this.hasClass('has-gallery')) {
              options.center = true;
              options.items = 5;
              options.autoWidth = true;
            }
            if ($this.hasClass('featured-slider')) {
              options.items = 1;
              options.autoHeight = true;
              options.navigation = false;
            }

            if ($this.hasClass('has-video')) {
              options.video = true;
              options.videoWidth = true;
              options.videoHeight = true;
              if ($(window).width() > 991) {
                setInterval(function playVideo() {
                  $('.hp-slider-video').each(function () {
                    this.play();
                  });
                }, 100);
              }
            }

            if ($this.hasClass('show-dots')) {
              options.dots = true;
              options.dotsContainer = '.top-pornstars-dots-container';
            }

            if ($this.hasClass('hp-slider-element')) {
              options.dots = true;
              options.dotsContainer = '.hp-slider-dots-container';
            }

            if ($this.hasClass('autoplay')) {
              options.autoplay = true;
              options.autoplayHoverPause = true;

              var interval_delay = $this.data('interval-delay');
              if (interval_delay) {
                options.autoplayTimeout = parseInt(interval_delay, 10);
              }
            }

            if ($this.hasClass('symbiotic')) {

              window.sym_move = false;
              var $symbiotic = $($this.data('symbiotic'));

              if ($symbiotic.length) {

                $this.on('changed.owl.carousel', function(event) {

                  if (window.sym_move) {
                    return;
                  }

                  window.sym_move = true;

                  var slider_data = $this.data('owlCarousel');

                  if (!slider_data) {
                    window.sym_move = false;
                    return;
                  }

                  var goTo = event.page.index,
                    sym_data = $symbiotic.data('owlCarousel'),
                    speed = slider_data._speed,
                    owl_current = $this.data('owl-current');

                  if (goTo === 0 && owl_current === event.item.count - 1 || goTo === event.item.count - 1 && owl_current === 0) {
                    speed = speed / event.item.count;
                  }

                  $this.data('owl-current', goTo);

                  setTimeout(function() {
                    window.sym_move = false;
                  }, 100);

                  $symbiotic.trigger('to.owl.carousel', [goTo, speed]);
                });

                $this.data('owl-current', 0);
              }
            }

            var carousel = $this.owlCarousel(options);

          });

        }
      }
    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    self.methods.slider._init();
  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      sorting_dropdown: '.sorting .sorting-dropdown',
      sorting_options: '.sorting .sorting-options > li',
      sorting_results: '.sorting-results'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      sorting: {
        _sort: function() {
          var $this = $(this);
          self.elements.sorting_options.not($this).removeClass('active');
          $this.addClass('active');
        },
        _dropdown: function() {
          var $this = $(this);
          $this.toggleClass('open');
        },
        _close: function() {
          self.elements.sorting_dropdown.removeClass('open');
        },
        _setup: function() {
          self.elements.sorting_results.mixItUp({
            load: {
              filter: 'all',
              sort: 'default:asc'
            },
            selectors: {
              sort: self.elements.sorting_options.selector,
              target: '.mix'
            },
            callbacks: {
              onMixEnd: function(state) {
                setTimeout(function() {
                  if (self.elements.sorting_results.hasClass('staggered-grid')) {
                    var c = 1,
                      height = null;
                    state.$targets.each(function() {
                      var $this = $(this),
                        $grid_item = $this.find('.grid-item'),
                        $grid_item_footer = $grid_item.find('.grid-texture-footer'),
                        large_class_col = 'col-xs-12 col-sm-12 col-md-8',
                        small_class_col = 'col-xs-12 col-sm-12 col-md-4',
                        large_class_grid_item = 'style-rectangle',
                        small_class_grid_item = 'style-narrower',
                        footer_class = 'stacked';

                      if (c === 1) {
                        height = $grid_item.outerHeight();
                      }

                      $grid_item.css('height', height);

                      $grid_item.addClass('abscover');

                      if (c === 1 || c === 7) {
                        $this.removeClass(small_class_col).addClass(large_class_col);
                        $grid_item.removeClass(small_class_grid_item).addClass(large_class_grid_item);
                        $grid_item_footer.removeClass(footer_class);
                      } else {
                        $this.removeClass(large_class_col).addClass(small_class_col);
                        $grid_item.removeClass(large_class_grid_item).addClass(small_class_grid_item);
                        $grid_item_footer.addClass(footer_class);
                      }

                      c++;

                      if (c > 7) {
                        c = 1;
                      }
                    });
                  }
                }, 0);
              }
            }
          });

        }
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'sorting._dropdown': {
        event: 'click.sorting._dropdown',
        element: self.elements.sorting_dropdown,
        action: self.methods.sorting._dropdown
      },
      'ESC_sorting._close': {
        event: window.object_name + '.html_esc',
        element: self.elements.body,
        action: self.methods.sorting._close
      },
      'HTML_sorting._close': {
        event: window.object_name + '.html_click',
        element: self.elements.window,
        action: self.methods.sorting._close
      }
    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    self.methods.sorting._setup();
  });

})(jQuery);

(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      accordian: '.accordian',
      accrodian_handle: '.accordian .handle',
      accordian_content: '.accordian .accordian-content'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    window.accordian_first_open = false;

    self.methods._add('methods', {
      accordian: {
        _toggle: function() {

          clearTimeout(window.trigger_scroll);

          var $this = $(this),
            $accordian = $this.parents('.accordian'),
            $content = $accordian.find('.accordian-content'),
            $content_inner = $content.find('.accordian-content-inner');

          self.elements.accordian.not($accordian).removeClass('open');
          self.elements.accordian_content.not($accordian).css('height', 0);

          $accordian.toggleClass('open');

          if ($accordian.hasClass('open')) {
            $content.css('height', $content_inner.outerHeight(true));
          } else {
            $content.css('height', 0);
          }
          if (!window.accordian_first_open) {
            window.trigger_scroll = setTimeout(function() {

              var $anchor = $accordian,
                offset = -self.elements.nav.outerHeight() + 1;

              if (self.elements.purchase_bar_height.length) {
                offset -= self.elements.purchase_bar_height.outerHeight();
              }

              if ($anchor.length && $accordian.offset().top < -offset + window.scrollY) {
                var scrollTo = $anchor.offset().top + offset;
                $("html, body").animate({
                  scrollTop: scrollTo
                }, 500);
                window[window.object_name].properties.smooth_scroll = true;
                window[window.object_name].properties.smooth_scroll_timeout = setTimeout(function() {
                  window[window.object_name].properties.smooth_scroll = true;
                }, 500);
              }
            }, 500);
          }

        }
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'accorian._toggle': {
        event: 'click.accorian._toggle',
        element: self.elements.accrodian_handle,
        action: self.methods.accordian._toggle
      }
    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    var $requested_open_accordians = self.elements.accordian.filter('.start-open');

    if ($requested_open_accordians.length) {
      window.accordian_first_open = true;
      $requested_open_accordians.each(function() {
        var $this = $(this),
          $handle = $this.find('.handle');

        $handle.trigger('click.accorian._toggle');
      });
      window.accordian_first_open = false;
    }
  });

})(jQuery);

// GIRLS PDP
(function($) {

  var $window = $(window);

  // ADD ELEMENTS
  $window.on(window.object_name + '._cache_elements', function(object_event, self) {

    self.methods._add('elements', {
      product_selection_visual: '.product-selection-visual',
      product_selection_options_orifice: '.product-selection-options input[type="radio"][name="product-orifice"]',
      product_selection_options_case: '.product-selection-options input[type="radio"][name="product-case"]',
      product_selection_visual_sleeve: '.product-selection-visual .sleeve',
      product_selection_visual_orifice: '.product-selection-visual .orifice',
      product_selection_visual_texture: '.product-selection-texture .texture',
      product_selection_description: '.product-selection-description .description',

      product_selection_steps: '.product-selection .steps .step',
      product_selection_steps_toggle: '[data-action="product-selection-toggle-step"]',
      product_selection_steps_next: '[data-action="product-selection-next"]',
      product_selection_steps_prev: '[data-action="product-selection-prev"]',
      product_selection_progress: '[data-var="product-selection-progress"]',

      product_selection_options_input: '.product-selection-options input',
      product_selection_options_requred: '.product-selection-options .steps .step.required',
      product_selection_options_purchase: '.product-selection-options-purchase',
      product_selection_options_total: '[data-var="product-selection-options-total"] span'
    });

  });

  // ADD METHODS
  $window.on(window.object_name + '._add_methods', function(object_event, self) {

    self.methods._add('methods', {
      product_selection: {
        _select_sleeve: function() {
          var $this = $(this),
            index = self.elements.product_selection_options_case.index($this),
            $request = self.elements.product_selection_visual_sleeve.eq(index);
          self.elements.product_selection_visual_sleeve.removeClass('active');
          $request.addClass('active');
        },
        _select_orifice: function() {

          var $this = $(this),
            index = self.elements.product_selection_options_orifice.index($this),
            $request = self.elements.product_selection_visual_orifice.eq(index);
          if ($('body').hasClass('product-girls') || $('body').hasClass('product-boys')) {
            var variantTitle = $this.attr('data-variant-title');
            $('span.mobile-title em').text(variantTitle);
          }

          if (!$request.length) {
            self.elements.product_selection_visual.addClass('no-orifice');
          } else {
            self.elements.product_selection_visual.removeClass('no-orifice');
          }

          self.elements.product_selection_visual_orifice.removeClass('active');
          $request.addClass('active');

          if (self.elements.product_selection_visual_texture.length) {
            self.elements.product_selection_visual_texture.removeClass('active');
            self.elements.product_selection_visual_texture.eq(index).addClass('active');
          }

          if (self.elements.product_selection_description.length) {
            self.elements.product_selection_description.removeClass('active');
            self.elements.product_selection_description.eq(index).addClass('active');
          }
        },
        _next: function() {
          var $open_step = self.elements.product_selection_steps.filter('.open'),
            $next_step = $open_step.next('.step'),
            next_index = 0;

          if ($next_step.length) {
            next_index = self.elements.product_selection_steps.index($next_step);
          } else {
            next_index = 0;
          }

          self.methods.product_selection._open_step(next_index);
        },
        _prev: function() {
          var $open_step = self.elements.product_selection_steps.filter('.open'),
            $prev_step = $open_step.prev('.step'),
            prev_index = null;

          if ($prev_step.length) {
            prev_index = self.elements.product_selection_steps.index($prev_step);
          } else {
            prev_index = self.elements.product_selection_steps.length - 1;
          }

          self.methods.product_selection._open_step(prev_index);
        },
        _toggle_step: function() {
          var $this = $(this),
            $step = $this.parents('.step');

          if ($step.hasClass('open')) {
            self.methods.product_selection._open_step(-1);
          } else {
            var index = self.elements.product_selection_steps.index($step);
            self.methods.product_selection._open_step(index);
          }
        },
        _open_step: function(step_index) {
          var $step = step_index >= 0 ? self.elements.product_selection_steps.eq(step_index) : false;
          self.elements.product_selection_steps.removeClass('open').find('.step-content').css('max-height', 0);

          self.elements.product_selection_steps.each(function() {
            var $this = $(this),
              $input = $this.find('input'),
              $selection = $input.filter(':checked'),
              complete = $selection.length ? true : false;

            if (complete) {
              $this.addClass('complete');
              var $completed_previews = $this.find('.step-complete .preview'),
                $completed_titles = $this.find('.step-complete .title'),
                selection_index = $input.index($selection);

              $completed_previews.removeClass('active').eq(selection_index).addClass('active');
              $completed_titles.removeClass('active').eq(selection_index).addClass('active');

            } else {
              $this.removeClass('complete');
            }
          });

          if ($step.length) {
            $step.addClass('open');
            var $step_content = $step.find('.step-content');
            $step_content.css('max-height', $step_content.find('.options').outerHeight(true));
            self.elements.product_selection_progress.text(step_index + 1);
          }
        },
        _check_required: function() {
          var required_complete = true;
          self.elements.product_selection_options_requred.each(function() {
            var $this = $(this),
              $input = $this.find('input');

            if (!$input.filter(':checked').length) {
              required_complete = false;
            }

          });

          if (required_complete) {
            self.elements.product_selection_options_purchase.removeClass('disabled');
          } else {
            self.elements.product_selection_options_purchase.addClass('disabled');
          }
        },
        _calculate_total: function() {

          $(self.elements.product_selection_options_total).css('opacity', 0);

          var new_total = 0,
            text = self.elements.product_selection_options_total.text(),
            regex = /[0-9]/;

          self.elements.product_selection_options_input.filter(':checked').each(function() {
            new_total += parseFloat($(this).data('price'), 10);
          });

          self.elements.product_selection_options_total.attr('data-geolizr-price', (new_total.toFixed(2) * 100).toString());
          $(document).trigger('calc');
        }
      }
    });

  });

  // ADD EVENTS
  $window.on(window.object_name + '._setup_events', function(object_event, self) {

    self.methods._add('events', {
      'product_selection._select_sleeve': {
        event: 'click.product_selection._select_sleeve',
        element: self.elements.product_selection_options_case,
        action: self.methods.product_selection._select_sleeve
      },
      'product_selection._select_orifice': {
        event: 'click.product_selection._select_orifice',
        element: self.elements.product_selection_options_orifice,
        action: self.methods.product_selection._select_orifice
      },
      'product_selection._toggle_step': {
        event: 'click.product_selection._open_step',
        element: self.elements.product_selection_steps_toggle,
        action: self.methods.product_selection._toggle_step
      },
      'product_selection._next': {
        event: 'click.product_selection._next',
        element: self.elements.product_selection_steps_next,
        action: self.methods.product_selection._next
      },
      'product_selection._prev': {
        event: 'click.product_selection._prev',
        element: self.elements.product_selection_steps_prev,
        action: self.methods.product_selection._prev
      },
      'product_selection._check_required': {
        event: 'change.product_selection._check_required',
        element: self.elements.product_selection_options_input,
        action: self.methods.product_selection._check_required
      },
      'product_selection._calculate_total': {
        event: 'change.product_selection._calculate_total',
        element: self.elements.product_selection_options_input,
        action: self.methods.product_selection._calculate_total
      }
    });

  });

  // RUN ON DOCUMENT READY
  $window.on(window.object_name + '._document_ready', function(object_event, self) {
    self.methods.product_selection._calculate_total();
  });

})(jQuery);

/* APP JS */

// @codekit-prepend "_setup.js";

(function($) {

  window[window.object_name] = {
    /*
     ** Function: object.inititalize();
     **	- fires primary methods
     */
    _initialize: function() {

      $window.trigger(window.object_name + '._initialize', self);
      $window.trigger(window.object_name + '._add_methods', self);

      $(document).ready(function() {
        self.document_ready();
      });
    },

    /*
     ** Object: elements
     **	- will be used to cache global elements;
     **	- object.methods._cache_elements() will cache elements
     **	- fired in object.runtime_methods();
     */
    elements: {},
    properties: {},
    methods: {

      _add: function(where, what) {
        jQuery.extend(true, self[where], what);
      },

      _setup_events: function(events) {
        for (var event in events) {

          var e = typeof events[event].event !== 'undefined' ? events[event].event : event;

          if (events[event].delegate) {
            events[event].delegate.on(e, events[event].element.selector, events[event].action);
          } else if (events[event].data) {
            events[event].element.on(e, events[event].data, events[event].action);
          } else {
            events[event].element.on(e, events[event].action);
          }
        }
      },
      /*
       ** Function: object.methods._cache_elements();
       **  - uses the same selectors object to cache elements
       */
      _cache_elements: function(selectors) {
        for (var key in selectors) {
          if (selectors[key].selector) {
            selectors[key] = $(selectors[key].selector);
          } else {
            selectors[key] = $(selectors[key]);
          }
        }

      },
      /*
       ** VENDROR METHODS
       **  - methods to build or interact with 3rd party vendor plugins
       */
      vendors: {}
    },
    events: {},
    document_ready: function() {

      // Global element caching must always run first
      $window.trigger(window.object_name + '._cache_elements', self);
      self.methods._cache_elements(self.elements);

      // Gather all events and assign them
      $window.trigger(window.object_name + '._setup_events', self);
      self.methods._setup_events(self.events);

      self.elements.window.trigger(window.object_name + '._document_ready', self);

      var resize_count = 0;
      window.resize_init = setInterval(function() {
        self.elements.window.trigger('resize');
        resize_count++;
        if (resize_count >= 20) {
          clearInterval(window.resize_init);
        }
      }, 100);

    }
  };

  var self = window[window.object_name],
    $window = $(window);

  window[window.object_name]._initialize();

})(jQuery);
